function snizeCustomFilterOptionsOrder() {

/*
MODIFICATION IS PROVIDED BY THE SEARCHANISE TEAM. WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

The modification allows setting the order of the Modell filter options by coping and pasting the order-value pairs from a CSV file.

You can update the filter options order by replacing the value of the filterImport variable. 

Please pay attention to the formatting:
1. Please note that it should not include column names or any additional columns.
2. The order column should always come first.
3. Be sure not to make any manual changes to the spacings or lines.
4. Please keep opening and closing backticks (``) on separate lines.

Here is an example of the expected format: 

let filterImport = 
`
1	iPhone 17
2	iPhone 17 Pro
3	iPhone 17 Pro Max
4	iPhone 17e
5	iPhone Air
`;

After making the changes, be sure to check if the search results page loads normally as errors in the modification may lead to the widget stop showing results. 

If you need to quickly disable the modification, you can do it by changing the isEnabled variable value from true to false: 
let isEnabled = false;

*/

// SETTINGS START

let filterImport = 
`
1	Acer Iconia Duo S14
2	Acer Iconia Duo S12
3	Acer Iconia Duo D12
4	Acer Iconia A11 (A11-21M)
5	Acer Iconia A11 (A11-11)
6	Acer Iconia V12 (V12-11M)
7	Acer Iconia V11 (V11-21M)
8	Acer Iconia V11 (V11-11)
9	Acer Iconia Tab A10
10	Acer Iconia Tab M10
11	Acer Iconia Tab P11
12	Acer Iconia Tab P10
13	Acer Iconia Tab 10 A3-A40
14	Acer Iconia Tab 10 A3-A30
15	Acer Iconia Tab A3-A20
16	Acer Iconia Tab 8 A1-840FHD
17	Acer Iconia X12
18	Acer Iconia Talk S
19	Acer Iconia One 8 B1-820
20	Acer Iconia One 7 B1-730
21	Acer Iconia B1-720
22	Acer Iconia A1-830
23	Acer Predator 8
24	AGM H6 / H6 Lite
25	AGM H6
26	AGM H6 Lite
27	Alcatel 1c (2019)
28	Alcatel 3X (2020)
29	ALLDOCUBE iPlay 80 mini Ultra
30	ALLDOCUBE iPlay 80 mini Pro
31	ALLDOCUBE iPlay 80 SE
32	ALLDOCUBE iPlay 70 Pad
33	ALLDOCUBE iPlay 70 Pad Pro
34	ALLDOCUBE Ultra Pad
35	Amazfit Balance 3
36	Amazfit Balance Ultra
37	Amazfit T-Rex 3 Pro (44mm)
38	Amazfit T-Rex 3 Pro (48mm)
39	Amazon Fire Phone
40	Amazon Alexa Tablet 8 (2026)
41	Amazon Alexa Tablet 11 (2026)
42	Alexa Tablet 12 Pro (2026)
43	Amazon Kids Tablet 8 (2026)
44	Amazon Kids Tablet 11 (2026)
45	Amazon Fire 7 (2022)
46	Amazon Fire 7 (2017/2019)
47	Amazon Fire 7 (2017)
48	Amazon Fire 7 (2019)
49	Amazon Fire HD 8 (2024)
50	Amazon Fire HD 8 Kids (2024)
51	Amazon Fire HD8 Kids Pro 2024
52	Amazon Fire HD 8 (2022)
53	Amazon FireHD 8 Kids Pro 2022
54	Amazon Fire HD 8 Plus (2022)
55	Amazon Fire HD 8/8 Plus 2020
56	Amazon Fire HD 8 (2020)
57	Amazon Fire HD 8 Plus (2020)
58	Amazon Fire HD 10 (2023)
59	Amazon Fire HD 10 Kids (2023)
60	Amazon FireHD10 Kids Pro 2023
61	Amazon Fire HD 10 (2021)
62	Amazon Fire HD 10 Plus (2021)
63	Amazon Fire HD 10 (2017/2019)
64	Amazon Fire HD 10 (2017)
65	Amazon Fire HD 10 (2019)
66	Amazon Fire Max 11
67	Amazon Kindle (2026)
68	Amazon Kindle (2024)
69	Amazon Kindle (2022)
70	Amazon Kindle (2019)
71	Amazon Kindle (2016)
72	Amazon Kindle Paperwhite 2026
73	Amazon Kindle Paperwhite 2024
74	Amazon Kindle Paperwhite 2021
75	Amazon Kindle Paperwhite 4
76	Amazon Kindle Paperwhite 1-3
77	Amazon Kindle Paperwhite 3
78	Amazon Kindle Paperwhite 2
79	Amazon Kindle Paperwhite 1
80	Amazon Kindle Colorsoft 2026
81	Amazon Kindle Colorsoft 2025
82	Amazon Kindle Scribe (2025)
83	Kindle Scribe Colorsoft(2025)
84	Amazon Kindle Scribe (2022)
85	Amazon Kindle Oasis (2019)
86	Amazon Kindle Oasis (2017)
87	Amazon Kindle Oasis (2016)
88	Amazon Kindle Voyage
89	iPhone 17 Pro/18 Pro
90	iPhone 17 Pro Max/18 Pro Max
91	iPhone 18 Pro
92	iPhone 18 Pro Max
93	iPhone Duo
94	iPhone 17
95	iPhone 17 Pro
96	iPhone 17 Pro Max
97	iPhone 17e
98	iPhone Air
99	iPhone 16
100	iPhone 16 Plus
101	iPhone 16 Pro
102	iPhone 16 Pro Max
103	iPhone 16e
104	iPhone 15
105	iPhone 15 Plus
106	iPhone 15 Pro
107	iPhone 15 Pro Max
108	iPhone 14
109	iPhone 14 Plus
110	iPhone 14 Pro
111	iPhone 14 Pro Max
112	iPhone 13 / 13 Pro
113	iPhone 13
114	iPhone 13 mini
115	iPhone 13 Pro
116	iPhone 13 Pro
117	iPhone 13 Pro Max
118	iPhone 12 / 12 Pro
119	iPhone 12
120	iPhone 12 mini
121	iPhone 12 Pro
122	iPhone 12 Pro Max
123	iPhone 11
124	iPhone 11 Pro
125	iPhone 11 Pro Max
126	iPhone X / iPhone XS
127	iPhone X
128	iPhone XS
129	iPhone XS Max
130	iPhone XR
131	iPhone 7 / iPhone 8
132	iPhone 8
133	iPhone 8
134	iPhone 8 Plus
135	iPhone 7
136	iPhone 7
137	iPhone 7 Plus
138	iPhone 7 Plus / iPhone 8 Plus
139	iPhone 6s / iPhone 6
140	iPhone 6
141	iPhone 6s
142	iPhone 6s Plus / 6 Plus
143	iPhone 6 Plus
144	iPhone 6s Plus
145	iPhone 5s / 5 / SE (2016)
146	iPhone 5
147	iPhone 5s
148	iPhone 5c
149	iPhone 4S / iPhone 4
150	iPhone 4S
151	iPhone 4
152	iPhone SE (2020/2022)
153	iPhone 7 / 8 / SE (2020/2022)
154	iPhone SE (2022)
155	iPhone SE (2022)
156	iPhone SE (2020)
157	iPhone SE (2020)
158	iPhone SE (2016)
159	iPad 10/11/12 (2022/25/26)
160	iPad 10 (2022)
161	iPad 11 (2025)
162	iPad 12 (2026)
163	iPad 7 / 8 / 9 (2019 - 2021)
164	iPad 7 / iPad Air 3 (2019)
165	iPad 9 (2021)
166	iPad 8 (2020)
167	iPad 7 (2019)
168	iPad 7 (2019)
169	iPad 5/6, Air 1/2, Pro 9.7
170	iPad 6 (2018)
171	iPad 5 (2017)
172	iPad 2 / 3 / 4 (2011 - 2012)
173	iPad 4 (2012)
174	iPad 3 (2012)
175	iPad 2 (2011)
176	iPad Pro 11 (2024/2025)
177	iPad Pro 11 (2024)
178	iPad Pro 11 (2025)
179	iPad Pro 13 (2024/2025)
180	iPad Pro 13 (2024)
181	iPad Pro 13 (2025)
182	iPad Pro 12.9 (2020-2022)
183	iPad Pro 12.9 (2018-2022)
184	iPad Pro 12.9 (2022)
185	iPad Pro 12.9 (2022)
186	iPad Pro 12.9 (2021)
187	iPad Pro 12.9 (2021)
188	iPad Pro 12.9 (2021)
189	iPad Pro 12.9 (2020)
190	iPad Pro 12.9 (2018 / 2020)
191	iPad Pro 12.9 (2020)
192	iPad Pro 12.9 (2020)
193	iPad Pro 12.9 (2018)
194	iPad Pro 12.9 (2018)
195	iPad Pro 12.9 (2015 / 2017)
196	iPad Pro 12.9 (2017)
197	iPad Pro 12.9 (2015)
198	iPad Pro 11 (2018-2022)
199	iPad Pro 11 (2020-2022)
200	iPad Pro 11 (2022)
201	iPad Pro 11 (2022)
202	iPad Pro 11 (2021)
203	iPad Pro 11 (2021)
204	iPad Pro 11 (2020)
205	iPad Pro 11 (2020)
206	iPad Pro 11 (2018)
207	iPad Pro 10.5 (2017)
208	iPad Pro 10.5 (2017)
209	iPad Pro 9.7 (2016)
210	iPad Air 11 (2024/25/26)
211	iPad Air 11 (2024)
212	iPad Air 11 (2025)
213	iPad Air 11 (2026)
214	iPad Air 13 (2024/25/26)
215	iPad Air 13 (2024)
216	iPad Air 13 (2025)
217	iPad Air 13 (2026)
218	iPad Air 4 / 5 (2020 / 2022)
219	iPad Air 5 (2022)
220	iPad Air 4 (2020)
221	iPad Air 3 / iPad Pro 10.5
222	iPad Air 3 (2019)
223	iPad Air 3 (2019)
224	iPad Air 2 (2014)
225	iPad Air 1 (2013)
226	iPad mini 8 (2026)
227	iPad mini 6 / 7 (2021 / 2024)
228	iPad mini 6 (2021)
229	iPad mini 7 (2024)
230	iPad mini 4 / 5 (2015 / 2019)
231	iPad mini 5 (2019)
232	iPad mini 5 (2019)
233	iPad mini 4 (2015)
234	iPad mini 4 (2015)
235	iPad mini 2/3/4/5 (2014-2019)
236	iPad mini 1/2/3 (2012-2014)
237	iPad mini 3 (2014)
238	iPad mini 3 (2014)
239	iPad mini 2 (2013)
240	iPad mini 2 (2013)
241	iPad mini 1 (2012)
242	iPad mini 1 (2012)
243	Apple Watch 12 (42mm)
244	Apple Watch 12 (46mm)
245	Apple Watch 11 (42mm)
246	Apple Watch 11 (46mm)
247	Apple Watch 10 (42mm)
248	Apple Watch 10 (46mm)
249	Apple Watch 9 (41mm)
250	Apple Watch 9 (45mm)
251	Apple Watch 8 (41mm)
252	Apple Watch 8 (45mm)
253	Apple Watch 7 (41mm)
254	Apple Watch 7 (45mm)
255	Apple Watch 6 (40mm)
256	Apple Watch 6 (44mm)
257	Apple Watch 5 (40mm)
258	Apple Watch 5 (44mm)
259	Apple Watch 4 (40mm)
260	Apple Watch 4 (44mm)
261	Apple Watch 3 (38mm)
262	Apple Watch 3 (42mm)
263	Apple Watch 2 (38mm)
264	Apple Watch 2 (42mm)
265	Apple Watch 1 (38mm)
266	Apple Watch 1 (42mm)
267	Apple Watch Ultra 4 (49mm)
268	Apple Watch Ultra 3 (49mm)
269	Apple Watch Ultra 2 (49mm)
270	Apple Watch Ultra 1 (49mm)
271	Apple Watch SE 3 (40mm)
272	Apple Watch SE 3 (44mm)
273	Apple Watch SE 2 (40mm)
274	Apple Watch SE 2 (44mm)
275	Apple Watch SE 1 (40mm)
276	Apple Watch SE 1 (44mm)
277	AirPods 4 / 5
278	AirPods 4
279	AirPods 5
280	AirPods 3
281	AirPods (1 / 2)
282	AirPods 2
283	AirPods 1
284	AirPods Pro 3
285	AirPods Pro (1 / 2)
286	AirPods Pro 2
287	AirPods Pro 1
288	Artfone C3
289	Artfone C1/C1+
290	Artfone C1
291	Artfone C1+
292	Artfone CS182
293	Asus Zenfone 12 Ultra
294	Asus Zenfone 11 Ultra
295	Asus Zenfone 10
296	Asus Zenfone 9
297	Asus Zenfone 8
298	Asus Zenfone 8 Flip
299	Asus Zenfone 7 / Zenfone 7Pro
300	Asus Zenfone 7
301	Asus Zenfone 7 Pro
302	Asus Zenfone 6 (2019)
303	Asus Zenfone 3 (ZE552KL)
304	Asus ROG Phone 9 / 9 Pro
305	Asus ROG Phone 9
306	Asus ROG Phone 9 Pro
307	Asus ROG Phone 8 / 8 Pro
308	Asus ROG Phone 8
309	Asus ROG Phone 8 Pro
310	Asus ROG Phone 7/7 Ultimate
311	Asus ROG Phone 7
312	Asus ROG Phone 7 Ultimate
313	Asus ROG Phone 6/6D Series
314	Asus ROG Phone 6
315	Asus ROG Phone 6 Pro
316	ROG Phone 6 Batman Edition
317	Asus ROG Phone 6D
318	Asus ROG Phone 6D Ultimate
319	Asus ROG Phone 5/5s Series
320	Asus ROG Phone 5
321	Asus ROG Phone 5 Ultimate
322	Asus ROG Phone 5 Pro
323	Asus ROG Phone 5s
324	Asus ROG Phone 5s Pro
325	Asus ROG Phone 3
326	Asus Zenpad 3S 10
327	Asus Zenpad Z10
328	Asus Zenpad Z8
329	Asus Zenpad 8.0
330	Asus Zenpad 10
331	Asus Zenpad 7.0
332	Asus Zenpad C 7.0
333	Bea-Fon M6
334	BlackBerry KEY2
335	BlackBerry KEY2 LE
336	BlackBerry KEYone
337	BlackBerry Motion
338	BlackBerry Priv
339	BlackBerry Passport
340	BlackBerry Classic
341	Blackview A200 Pro
342	Blackview A100
343	Blackview A95
344	Blackview A90
345	Blackview A80 / A80 Pro
346	Blackview A80
347	Blackview A80 Pro
348	Blackview A70
349	Blackview A60
350	Blackview A55
351	Blackview A55 Pro
352	Blackview A53 / A53 Pro
353	Blackview A53
354	Blackview A53 Pro
355	Blackview A52
356	Blackview BL9000 / BL9000 Pro
357	Blackview BL9000
358	Blackview BL9000 Pro
359	Blackview BL8000
360	Blackview BL7000
361	Blackview BV9800 Pro
362	Blackview BV9300
363	Blackview BV8200
364	Blackview BV8100
365	Blackview BV7300
366	Blackview BV4900 Pro
367	Blackview BV4800 / BV4800 Pro
368	Blackview BV4800
369	Blackview BV4800 Pro
370	Blackview N6000
371	Blackview N2000
372	Blackview N1000
373	Blackview Color 8
374	Blackview Color 6
375	Blackview Fort 100
376	Blackview Fort 5
377	Blackview Fort 2
378	Blackview Fort 1
379	Blackview Hero 10
380	Blackview Rock 5
381	Blackview Rock 3
382	Blackview Rock 2
383	Blackview Rock 2 Pro
384	Blackview Rock 1
385	Blackview Rock 1 Pro
386	Blackview Shark 9
387	Blackview Shark 8
388	Blackview Shark 6
389	Blackview Wave 10
390	Blackview Wave 9C
391	Blackview Wave 8
392	Blackview Wave 8C
393	Blackview Wave 7C
394	Blackview Wave 6C
395	Blackview Xplore 6
396	Blackview Xplore 2
397	Blackview Xplore 1
398	Blackview Xplore 1 Pro
399	Blackview Xplore X1
400	Blackview Tab 90
401	Blackview Tab 80
402	Blackview Tab 70 WiFi
403	Blackview Tab 60
404	Blackview Tab 60 Pro
405	Blackview Tab 50 WiFi
406	Blackview Tab 18
407	Blackview Tab 16
408	Blackview Tab 16 Pro
409	Blackview Tab 15
410	Blackview Tab 15 Pro
411	Blackview Tab 13
412	Blackview Tab 13 Pro
413	Blackview Tab 12
414	Blackview Tab 12 Pro
415	Blackview Tab 11
416	Blackview Tab 11 WiFi
417	Blackview Tab 11 SE
418	Blackview Tab 10
419	Blackview Tab 10 WiFi
420	Blackview Tab 10 Pro
421	Blackview Tab 9
422	Blackview Tab 8 WiFi
423	Blackview Tab 7
424	Blackview Tab 7 Pro
425	Blackview Tab 7 WiFi
426	Blackview Tab 6
427	Blackview Tab 5
428	Blackview Active 12 Pro
429	Blackview Active 10 Pro
430	Blackview Active 8
431	Blackview Active 8 Pro
432	Blackview Active 6
433	Blackview MEGA 12
434	Blackview MEGA 8
435	Blackview MEGA 3
436	Blackview MEGA 2
437	Blackview MEGA 1
438	Blackview Link 8
439	Blackview Link 2
440	Blackview Zeno 10
441	Blackview Zeno 1
442	BOOX Go 10.3 (Gen II)
443	BOOX Go 6 (Gen II)
444	BOOX Note Air6 C
445	BOOX Note Air5 C
446	BOOX Note Max
447	BOOX Note Mini C
448	BQ Aquaris X Pro
449	BQ Aquaris M10
450	CAT S75
451	CAT S62 Pro
452	CAT S61
453	CAT S60
454	CAT S53
455	CAT S52
456	CAT S42
457	CAT S31
458	CAT S41
459	CAT B40
460	CMF Phone 2 Pro
461	CMF Phone 1
462	Crosscall Stellar-M6 / M6E
463	Crosscall Stellar-M6
464	Crosscall Stellar-M6E
465	Crosscall Stellar-X5
466	Crosscall Core-M6
467	Crosscall Core-S5
468	Crosscall Core-X5
469	Crosscall Core-T5
470	Cubot Note 50
471	Cubot Note 40
472	Cubot A30
473	Cubot A20
474	Cubot A10
475	Cubot A1
476	Cubot X90
477	Cubot X70
478	Cubot X30
479	Cubot KingKong 9
480	Cubot KingKong 8
481	Cubot King Kong 5
482	Cubot KingKong Ace 3
483	Cubot KingKong AX
484	Cubot KingKong X
485	Cubot KingKong ES
486	Cubot King Kong CS
487	Cubot Kingkong Mini 3
488	Cubot Max 5
489	Cubot Max 3
490	Cubot J20
491	Cubot P80
492	Cubot P50
493	Cubot Pocket 3
494	Cubot Tab 65
495	Cubot Tab 60
496	Cubot Tab 50
497	Cubot Tab 40
498	Cubot Tab 30
499	Cubot Tab 20
500	Cubot Tab 10
501	Cubot Tab KingKong
502	Cubot Tab KingKong Mini
503	Cubot Tab KingKong S
504	Doogee Note 59/59 Pro/59 Pro+
505	Doogee Note 59
506	Doogee Note 59 Pro
507	Doogee Note 59 Pro Plus
508	Doogee Note 58 / 58 Pro
509	Doogee Note 58
510	Doogee Note 58 Pro
511	Doogee Note 56/56 Plus/56 Pro
512	Doogee Note 56
513	Doogee Note 56 Plus
514	Doogee Note 56 Pro
515	Doogee N55/N55 Plus/N55 Pro
516	Doogee N55
517	Doogee N55 Plus
518	Doogee N55 Pro
519	Doogee N50
520	Doogee N50 Pro
521	Doogee S300 Plus / S300 Pro
522	Doogee S300 Plus
523	Doogee S300 Pro
524	Doogee S200 / S200 Pro
525	Doogee S200
526	Doogee S200 Pro
527	Doogee S200X
528	Doogee S118
529	Doogee S110
530	Doogee S100 Pro
531	Doogee S98
532	Doogee S98 Pro
533	Doogee S96 Pro
534	Doogee S61 / S61 Pro
535	Doogee S61
536	Doogee S61 Pro
537	Doogee S41 / S41 Pro
538	Doogee S41
539	Doogee S41 Pro
540	Doogee S40 Pro
541	Doogee S Cyber
542	Doogee S Punk
543	Doogee Smini
544	Doogee V31GT
545	Doogee V20
546	Doogee V20 PRO
547	Doogee V20S
548	Doogee V Max 2 / V Max 2 Pro
549	Doogee V Max 2
550	Doogee V Max 2 Pro
551	Doogee V Max
552	Doogee V Max Plus
553	Doogee V Max Play
554	Doogee V Max LR
555	Doogee X95
556	Doogee Blade 20 Series
557	Doogee Blade 10/10 Pro/Ultra
558	Doogee Blade 10
559	Doogee Blade 10 Pro
560	Doogee Blade 10 Ultra
561	Doogee Blade 10 Max
562	Doogee DK10
563	Doogee Fire 7
564	Doogee Fire 7 Pro
565	Doogee Fire 7 Ultra
566	Doogee Fire 6
567	Doogee Fire 6 Power
568	Doogee Fire 6 Max
569	Doogee Fire 5/5 Pro/5 Ultra
570	Doogee Fire 5
571	Doogee Fire 5 Pro
572	Doogee Fire 5 Ultra
573	Doogee Fire 3 Pro / 3 Ultra
574	Doogee Fire 3 Pro
575	Doogee Fire 3 Ultra
576	Doogee Tab A9
577	Doogee Tab A9 Plus
578	Doogee Tab A9 Pro
579	Doogee Tab A9 Pro Plus
580	Doogee Tab E3
581	Doogee Tab E3 Plus
582	Doogee Tab E3 Max
583	Doogee Tab E3 Pro
584	Doogee Tab G6
585	Doogee Tab G6 Plus
586	Doogee Tab G6 Max
587	Doogee R20
588	Doogee R10
589	Doogee R08
590	Doogee T40
591	Doogee T40 Pro
592	Doogee T30E
593	Doogee T30S
594	Doogee T30 Pro
595	Doogee T30 Ultra
596	Doogee T30 Max
597	Doogee T20
598	Doogee T20 mini
599	Doogee T20 mini Pro
600	Doogee T20 Ultra
601	Doogee T20S
602	Doogee T10
603	Doogee T10 Pro
604	Doogee T10 Plus
605	Doogee T10E
606	Doogee T10S
607	Doogee T10W
608	Doogee U13
609	Doogee U12
610	Doogee U11
611	Doogee U11 Pro
612	Doogee U10
613	Doogee U10 Pro
614	Doogee U9
615	Doogee V Pad 5G
616	Doro Aurora A30
617	Doro Aurora A20
618	Doro Aurora A10
619	Doro 8200
620	Doro 8100 / Doro 8100 Plus
621	Doro 8100
622	Doro 8100 Plus
623	Doro 8080
624	Doro 8050
625	Doro 8040
626	Doro 8035
627	Doro 1370
628	Doro 780X
629	Doro Tablet
630	Emporia SMART.8
631	Emporia SMART.7 Lite
632	Emporia SMART.7 mini
633	Emporia SMART.ME7
634	Emporia ME.6
635	Emporia SMART.6
636	Emporia SMART.6 Lite
637	Emporia SMART.5
638	Emporia SMART.5 mini
639	Emporia SMART.4
640	Emporia SMART.3mini
641	Emporia Simplicity
642	Emporia SUPEREASY
643	Emporia Euphoria V50
644	Emporia TABLET
645	Fairphone 6
646	Fairphone 5
647	Fairphone 4
648	Fairphone 3 / 3 Plus
649	Fairphone 3
650	Fairphone 3 Plus
651	Garmin Venu 3 (45mm)
652	Gigaset GS6 / GS6 Pro
653	Gigaset GS6
654	Gigaset GS6 Pro
655	Gigaset GS5
656	Gigaset GS5 Lite/GS5 Senior
657	Gigaset GS5 Lite
658	Gigaset GS5 Senior
659	Gigaset GS4
660	Gigaset GS290
661	Gigaset GS195
662	Gigaset GS190
663	Gigaset GS110
664	Gigaset GX50
665	Gigaset GX30
666	Gigaset GX6
667	Gigaset GX4
668	Gigaset GX290
669	Google Pixel 11
670	Google Pixel 11 Pro
671	Google Pixel 11 Pro XL
672	Google Pixel 11 Pro Fold
673	Google Pixel 10
674	Google Pixel 10 Pro
675	Google Pixel 10 Pro XL
676	Google Pixel 10 Pro Fold
677	Google Pixel 10a
678	Google Pixel 9
679	Google Pixel 9 Pro
680	Google Pixel 9 Pro XL
681	Google Pixel 9 Pro Fold
682	Google Pixel 9a
683	Google Pixel 8
684	Google Pixel 8 Pro
685	Google Pixel 8a
686	Google Pixel 7
687	Google Pixel 7 Pro
688	Google Pixel 7a
689	Google Pixel 6
690	Google Pixel 6 Pro
691	Google Pixel 6a
692	Google Pixel 5
693	Google Pixel 4
694	Google Pixel 4 XL
695	Google Pixel 4a
696	Google Pixel 4a 5G
697	Google Pixel 3
698	Google Pixel 3 XL
699	Google Pixel 3a
700	Google Pixel 3a XL
701	Google Pixel 2
702	Google Pixel 2 XL
703	Google Pixel
704	Google Pixel XL
705	Google Pixel Fold
706	Google Pixel Tablet
707	Google Pixel Watch 5 (41mm)
708	Google Pixel Watch 5 (45mm)
709	Google Pixel Watch 4 (41mm)
710	Google Pixel Watch 4 (45mm)
711	Google Pixel Watch 3 (41mm)
712	Google Pixel Watch 3 (45mm)
713	Google Pixel Watch 2
714	Google Pixel Watch 1
715	Hafury Meet
716	Hafury V1
717	Hafury GT20
718	HMD Arc
719	HMD Fusion
720	HMD Skyline
721	HMD Pulse / Pulse Plus
722	HMD Pulse
723	HMD Pulse Plus
724	HMD Pulse Pro
725	HMD Barbie Phone
726	Honor 600
727	Honor 600 Pro
728	Honor 600 Lite
729	Honor 600 Smart
730	Honor 400
731	Honor 400 Pro
732	Honor 400 Lite
733	Honor 400 Smart (4G/5G)
734	Honor 400 Smart (4G)
735	Honor 400 Smart 5G
736	Honor 200
737	Honor 200 Pro
738	Honor 200 Lite
739	Honor 200 Smart
740	Honor 90 Lite
741	Honor 90
742	Honor 70
743	Honor 50
744	Honor 50 Lite
745	Honor 20
746	Honor 20 Lite / 20e
747	Honor 20 Lite
748	Honor 20e
749	Honor 20 Pro
750	Honor 9X
751	Honor 9X Pro
752	Honor 9X Lite
753	Honor 8A (2019)
754	Honor 8S
755	Honor X8 (4G)
756	Honor X8 5G
757	Honor X8a
758	Honor X8d
759	Honor X7
760	Honor X6a
761	Honor X6b
762	Honor X5c / X5c Plus
763	Honor X5c
764	Honor X5c Plus
765	Honor Magic8 Pro
766	Honor Magic8 Lite
767	Honor Magic7 Pro
768	Honor Magic7 Lite
769	Honor Magic6 Pro
770	Honor Magic6 Lite
771	Honor Magic5 Pro
772	Honor Magic5 Lite
773	Honor Magic4 Pro
774	Honor Magic4 Lite 5G
775	Honor Magic V6
776	Honor Magic V5
777	Honor Magic V3
778	Honor Magic V2
779	Honor Magic Vs
780	Honor Play
781	Honor MagicPad 4
782	Honor MagicPad 2
783	Honor Pad V9
784	Honor Pad 10
785	Honor Pad 9
786	Honor Pad 8
787	Honor Pad X9
788	Honor Pad X9a
789	Honor Pad X9 Max
790	Honor Pad X8
791	Honor Pad X8a
792	HTC U24 Pro
793	HTC U23 Pro
794	HTC U12 Plus
795	HTC U12 Life
796	HTC U11
797	HTC U11 Life
798	HTC U11 Plus
799	HTC U Ultra
800	HTC Desire 22 Pro
801	HTC Desire 12 Plus
802	HTC Desire 626G
803	HTC 10
804	HTC One M9
805	HTC One M8 / M8s
806	HTC One M8
807	HTC One M8s
808	HTC One M7
809	Huawei Pura 90
810	Huawei Pura 80 Pro
811	Huawei Pura 80 Ultra
812	Huawei Pura 70
813	Huawei Pura 70 Pro
814	Huawei Pura 70 Ultra
815	Huawei P60 / P60 Pro
816	Huawei P60
817	Huawei P60 Pro
818	Huawei P50 Pro
819	Huawei P40
820	Huawei P40 Pro / P40 Pro Plus
821	Huawei P40 Pro
822	Huawei P40 Pro Plus
823	Huawei P40 Lite
824	Huawei P40 Lite E
825	Huawei P40 Lite 5G
826	Huawei P30
827	Huawei P30 Pro/P30 Pro New Ed
828	Huawei P30 Pro
829	Huawei P30 Pro New Edition
830	Huawei P30 Lite/P30 Lite New
831	Huawei P30 Lite
832	Huawei P30 Lite New Edition
833	Huawei P20
834	Huawei P20 Pro
835	Huawei P20 Lite
836	Huawei P20 Lite (2019)
837	Huawei P10
838	Huawei P10 Plus
839	Huawei P10 Lite
840	Huawei P9
841	Huawei P9 Plus
842	Huawei P9 Lite
843	Huawei P8
844	Huawei P8 Lite 2015
845	Huawei P8 Lite 2017
846	Huawei Ascend P7
847	Huawei P smart 2021
848	Huawei P smart 2020
849	Huawei P smart 2019
850	Huawei P smart (2017)
851	Huawei P smart Plus 2019
852	Huawei P smart Plus
853	Huawei P smart Pro
854	Huawei P smart Z
855	Huawei Mate X7
856	Huawei Mate X6
857	Huawei Mate 80 Pro
858	Huawei Mate 50 Pro
859	Huawei Mate 40 Pro
860	Huawei Mate 30 Pro
861	Huawei Mate 20
862	Huawei Mate 20 Pro
863	Huawei Mate 20 Lite
864	Huawei Mate 20 X
865	Huawei Mate 10 Pro
866	Huawei Mate 10 Lite
867	Huawei Mate 9
868	Huawei Mate 9 Pro
869	Huawei Mate 9 Lite
870	Huawei Mate 8
871	Huawei Ascend Mate 7
872	Huawei nova 14 Pro
873	Huawei nova 13
874	Huawei nova 13 Pro
875	Huawei nova 12s
876	Huawei nova 12i
877	Huawei nova 12 SE
878	Huawei nova 9 / Honor 50
879	Huawei nova 9
880	Huawei nova 9 SE
881	Huawei nova 8i/ Honor 50 Lite
882	Huawei nova 8i
883	Huawei nova 5T
884	Huawei nova 2
885	Huawei Nova
886	Huawei Nova Plus
887	Huawei Ascend Y530
888	Huawei Ascend Y300
889	Huawei G8 / GX8
890	Huawei G8
891	Huawei GX8
892	Huawei Y9 (2019)
893	Huawei Y7 / Y7 Prime (2019)
894	Huawei Y7 (2019)
895	Huawei Y7 Prime (2019)
896	Huawei Y7 / Y7 Prime (2017)
897	Huawei Y7 (2017)
898	Huawei Y7 Prime (2017)
899	Huawei Y6 (2019)
900	Huawei Y6 (2018)
901	Huawei Y6 (2017)
902	Huawei Y6 (2015)
903	Huawei Y6p
904	Huawei Y6s
905	Huawei Y5 (2019)
906	Huawei Y5p
907	Huawei Y625
908	Huawei Honor View 20
909	Huawei Honor View 10
910	Huawei Honor 10
911	Huawei Honor 10 Lite
912	Huawei Honor 9
913	Huawei Honor 9 Lite
914	Huawei Honor 8
915	Huawei Honor 8X
916	Huawei Honor 8X Max
917	Huawei Honor 7 / 7 Premium
918	Huawei Honor 7
919	Huawei Honor 7 Premium
920	Huawei Honor 7X
921	Honor6X / GR5 (2017)
922	Huawei Honor 6
923	Huawei Honor 6X
924	Huawei Honor 5X / GR5(2016)
925	Huawei Honor 5X
926	Huawei Honor 5C
927	Huawei GR5 (2017)
928	Huawei GR5 (2016)
929	Huawei MatePad Air (2026)
930	Huawei MatePad 12X (2025)
931	Huawei MatePad 12X (2024)
932	Huawei MatePad 11.5 S (2026)
933	Huawei MatePad 11.5 S (2025)
934	Huawei MatePad 11.5 S (2024)
935	Huawei MatePad 11.5 (2025)
936	Huawei MatePad 11.5 (2023)
937	Huawei MatePad 11 (2023)
938	Huawei MatePad 11 (2021)
939	Huawei MatePad 10.4 (2022)
940	Huawei MatePad 10.4 (2020)
941	Huawei MatePad Pro Max (2026)
942	Huawei MatePad Pro 13.2(2025)
943	Huawei MatePad Pro 13.2(2024)
944	Huawei MatePad Pro 12.2(2025)
945	Huawei MatePad Pro 12.2(2024)
946	Huawei MatePad Pro 12.6(2021)
947	Huawei MatePad Pro 12 (2026)
948	Huawei MatePad Pro 11 (2022)
949	Huawei MatePad Pro 10.8(2021)
950	Huawei MatePad Pro (2019)
951	Huawei MatePad T 10
952	Huawei MatePad T 10s
953	Huawei MatePad T 8
954	Huawei MatePad SE 11
955	Huawei MatePad SE
956	Huawei MatePad Paper
957	Huawei MediaPad M5 (8.4)
958	Huawei MediaPad M5/Pro (10.8)
959	Huawei MediaPad M5 (10.8)
960	Huawei MediaPad M5 Pro (10.8)
961	Huawei MediaPad M5 Lite (8)
962	Huawei MediaPad M5 Lite (10)
963	Huawei MediaPad M3 Lite 10
964	Huawei MediaPad M3 8.4
965	Huawei MediaPad M3 Lite 8
966	Huawei MediaPad M2 10.0
967	Huawei MediaPad M2 8.0
968	Huawei MediaPad M2 7.0
969	Huawei MediaPad M1
970	Huawei MediaPad T5
971	Huawei MediaPad T3 10
972	Huawei MediaPad T3 8
973	Huawei MediaPad T3 7
974	Huawei MediaPad T2 10.0 Pro
975	Huawei MediaPad T2 7.0
976	Huawei MediaPad T2 7.0 Pro
977	Huawei MediaPad T1 10
978	Huawei MediaPad T1 8.0
979	Huawei MediaPad T1 7.0
980	Huawei Honor Pad 2
981	Huawei Watch GT 7 (41mm)
982	Huawei Watch GT 7 (46mm)
983	Huawei Watch GT 7 Pro
984	Huawei Watch GT6/GT6 Pro 46mm
985	Huawei Watch GT 6 (46mm)
986	Huawei Watch GT 6 Pro (46mm)
987	Huawei Watch GT5/GT5 Pro 46mm
988	Huawei Watch GT 5 (46mm)
989	Huawei Watch GT 5 Pro (46mm)
990	Huawei Watch GT 4 (46mm)
991	Huawei Watch GT3/GT3 Pro 46mm
992	Huawei Watch GT 3 (46mm)
993	Huawei Watch GT 3 Pro (46mm)
994	Huawei Watch D3
995	JIKOCXN C30
996	Kobo Elipsa 2E
997	Kobo Clara BW
998	Kobo Clara Colour
999	Kobo Clara 2E
1000	Kobo Libra Colour
1001	Kobo Libra 2
1002	Kobo Sage
1003	Kobo Nia
1004	KXD A1
1005	Leitzphone powered by Xiaomi
1006	Lenovo ThinkTab X11 Gen 1
1007	Lenovo Tab (10.1, 2025)
1008	Lenovo Tab Plus Gen 2
1009	Lenovo Tab Plus
1010	Lenovo Tab One
1011	Lenovo Tab K11 Gen 2
1012	Lenovo Tab K11e
1013	Lenovo Tab K11 Plus
1014	Lenovo Tab K10
1015	Lenovo Tab P12
1016	Lenovo Tab P12 Pro
1017	Lenovo Tab P11(Gen1)/P11 Plus
1018	Lenovo Tab P11 (2. Gen.)
1019	Lenovo Tab P11 (Gen 1)
1020	Lenovo Tab P11 Plus
1021	Lenovo Tab P11 Pro (2. Gen.)
1022	Lenovo Tab P11 Pro (1. Gen.)
1023	Lenovo Tab M11
1024	Lenovo Tab M10 5G (2023)
1025	Lenovo Tab M10 (3. Gen.)
1026	Lenovo Tab M10 HD (2. Gen.)
1027	Lenovo Tab M10 (1. Gen.)
1028	Lenovo Tab M10 Plus (3. Gen.)
1029	Lenovo Tab M10 Plus (2. Gen.)
1030	Lenovo Tab M9
1031	Lenovo Tab M8 (4. Gen.)
1032	Lenovo Tab M8 (3. Generation)
1033	Lenovo Tab M8 (2.Gen.) HD/FHD
1034	Lenovo Tab M8 (2. Gen.) HD
1035	Lenovo Tab M8 (2. Gen.) FHD
1036	Lenovo Tab M7 (3. Gen.)
1037	Lenovo Tab M7 (2. Gen.)
1038	Lenovo Yoga Tab Gen 2
1039	Lenovo Yoga Tab (11.1, 2025)
1040	Lenovo Yoga Tab Plus Gen 2
1041	Lenovo Yoga Tab Plus (2025)
1042	Lenovo Yoga Smart Tab
1043	Lenovo Yoga Tab 3 Plus
1044	Lenovo Yoga Tab 3 10
1045	Lenovo Yoga Tab 3 Pro
1046	Lenovo Legion Tab Gen 5
1047	Lenovo Legion Tab Gen 3
1048	Lenovo Legion Tab
1049	Lenovo Idea Tab (11.0, 2025)
1050	Lenovo Idea Tab Plus (2025)
1051	Lenovo Idea Tab Pro Gen 2
1052	Lenovo Idea Tab Pro
1053	Lenovo Smart Paper
1054	Lenovo Tab Extreme
1055	Lenovo Tab 4 10 Plus
1056	Lenovo Tab 4 10
1057	Lenovo Tab 4 8 Plus
1058	Lenovo Tab 4 8
1059	Lenovo Tab3 8 Plus
1060	Lenovo Tab3 10
1061	Lenovo Tab3 8
1062	Lenovo Tab3 7
1063	Lenovo Tab 2 A10-70
1064	Lenovo Tab 2 A8-50
1065	Lenovo Tab 2 A7-30
1066	Lenovo Tab 2 A7-20
1067	Lenovo Tab 2 A7-10
1068	LG G8 ThinQ
1069	LG G8s ThinQ
1070	LG G8X ThinQ
1071	LG G7 ThinQ / G7 Fit
1072	LG G7 ThinQ
1073	LG G7 Fit
1074	LG G6
1075	LG G5
1076	LG G4
1077	LG G3
1078	LG G2
1079	LG G Flex 2
1080	LG K61
1081	LG K52
1082	LG K51S
1083	LG K50
1084	LG K50s
1085	LG K42 / K52
1086	LG K42
1087	LG K41S
1088	LG K40
1089	LG K40s
1090	LG K20
1091	LG K10 (2017)
1092	LG K10 (2016)
1093	LG K8 (2017)
1094	LG K4 (2017)
1095	LG K4 (2016)
1096	LG V40 ThinQ
1097	LG V30
1098	LG V30 Plus
1099	LG Q60
1100	LG Q6
1101	LG X Power 3
1102	LG X Power 2
1103	LG X Power
1104	LG X Screen
1105	LG Velvet / LG Velvet 5G
1106	LG Velvet
1107	LG Velvet 5G
1108	LG Wing
1109	LG Google Nexus 5
1110	LG Google Nexus 5X
1111	LG Stylus 2
1112	LG G Pad IV 8.0
1113	LG G Pad II 10.1
1114	LG G Pad 10.1
1115	LG G Pad 8.3
1116	LG G Pad 8.0
1117	Microsoft Lumia 950
1118	Microsoft Lumia 950 XL
1119	Microsoft Lumia 650
1120	Microsoft Lumia 640
1121	Microsoft Lumia 640 XL
1122	Microsoft Lumia 535
1123	Microsoft Lumia 435
1124	Surface Pro X
1125	Surface Pro (13", 2026)
1126	Surface Pro (12", 2026)
1127	Surface Pro (12", 2025)
1128	Surface Pro 11
1129	Surface Pro 9
1130	Surface Pro 8
1131	Surface Pro 4/5/6/7
1132	Surface Pro 7
1133	Surface Pro 7 Plus
1134	Surface Pro 6
1135	Surface Pro 5
1136	Surface Pro 4
1137	Surface Go 4
1138	Surface Go 3
1139	Surface Go 2 (10.5)
1140	Surface Go (10inch)
1141	Motorola Signature
1142	Motorola Signature 27
1143	Motorola Moto G200 5G
1144	Motorola Moto G100
1145	Motorola Moto G87
1146	Motorola Moto G86 5G
1147	Motorola Moto G86 Power 5G
1148	Motorola Moto G85 5G
1149	Motorola Moto G84 5G
1150	Motorola Moto G82 5G
1151	Motorola Moto G77
1152	Motorola Moto G75 5G
1153	Motorola Moto G73 5G
1154	Motorola Moto G72
1155	Motorola Moto G71 5G
1156	Motorola Moto G67/G77
1157	Motorola Moto G67
1158	Motorola Moto G62 5G
1159	Motorola Moto G60s
1160	Motorola Moto G57 Power
1161	Motorola Moto G56 5G
1162	Motorola Moto G55 5G
1163	Motorola Moto G54 5G
1164	Motorola Moto G53 5G
1165	Motorola Moto G52
1166	Motorola Moto G51 5G
1167	Motorola Moto G50
1168	Motorola Moto G47
1169	Motorola Moto G42
1170	Motorola Moto G41
1171	Motorola Moto G37 / G47
1172	Motorola Moto G37
1173	Motorola Moto G37 Power
1174	Motorola Moto G35 5G
1175	Motorola Moto G34 5G
1176	Motorola Moto G32
1177	Motorola Moto G31 / G41
1178	Motorola Moto G31
1179	Motorola Moto G30
1180	Motorola Moto G24
1181	Motorola Moto G23
1182	Motorola Moto G22
1183	Motorola Moto G20
1184	Motorola Moto G17
1185	Motorola Moto G15
1186	Motorola Moto G14
1187	Motorola Moto G13 / G23
1188	Motorola Moto G13
1189	Motorola Moto G10 / G30
1190	Motorola Moto G10
1191	Motorola Moto G06
1192	Motorola Moto G06 Power
1193	Motorola Moto G05
1194	Motorola Moto G04 / G04s
1195	Motorola Moto G04
1196	Motorola Moto G04s
1197	Motorola Moto G9 Play
1198	Motorola Moto G9 Plus
1199	Motorola Moto G9 Power
1200	Motorola Moto G8
1201	Motorola Moto G8 Plus
1202	Motorola Moto G8 Power
1203	Motorola Moto G8 Power Lite
1204	Motorola Moto G7
1205	Motorola Moto G7 Plus
1206	Motorola Moto G7 Play
1207	Motorola Moto G7 Power
1208	Motorola Moto G6
1209	Motorola Moto G6 Plus
1210	Motorola Moto G5
1211	Motorola Moto G5 Plus
1212	Motorola Moto G5s
1213	Motorola Moto G5s Plus
1214	Motorola Moto G4 / G4 Plus
1215	Motorola Moto G4
1216	Motorola Moto G4 Plus
1217	Motorola Moto G4 Play
1218	Motorola Moto G3
1219	Motorola Moto G2
1220	Motorola Moto G
1221	Motorola Moto G 5G
1222	Motorola Moto G 5G Plus
1223	Motorola Edge 70
1224	Motorola Edge 70 Pro
1225	Motorola Edge 70 Fusion
1226	Motorola Edge 70 Max
1227	Motorola Edge 70 Plus
1228	Motorola Edge 70 Neo
1229	Motorola Edge 60
1230	Motorola Edge 60 Neo
1231	Motorola Edge 60 Pro
1232	Motorola Edge 60 Fusion
1233	Motorola Edge 50 Pro
1234	Motorola Edge 50 Ultra
1235	Motorola Edge 50 Fusion
1236	Motorola Edge 50 Neo
1237	Motorola Edge 40
1238	Motorola Edge 40 Pro
1239	Motorola Edge 40 Neo
1240	Motorola Edge 30
1241	Motorola Edge 30 Pro
1242	Motorola Edge 30 Ultra
1243	Motorola Edge 30 Neo
1244	Motorola Edge 30 Fusion
1245	Motorola Edge 20
1246	Motorola Edge 20 Pro
1247	Motorola Edge 20 Lite
1248	Motorola Razr Fold
1249	Motorola Razr 70
1250	Motorola Razr 70 Plus
1251	Motorola Razr 70 Ultra
1252	Motorola Razr 60
1253	Motorola Razr 60 Ultra
1254	Motorola Razr 50
1255	Motorola Razr 50 Ultra
1256	Motorola Razr 40 Ultra
1257	Motorola ThinkPhone 25
1258	Motorola ThinkPhone
1259	Motorola Defy (2021)
1260	Motorola Moto E30 / E40
1261	Motorola Moto E40
1262	Motorola Moto E32 / E32s
1263	Motorola Moto E32
1264	Motorola Moto E32s
1265	Motorola Moto E30
1266	Motorola Moto E22 / E22i
1267	Motorola Moto E22
1268	Motorola Moto E22i
1269	Motorola Moto E20
1270	Motorola Moto E15
1271	Motorola Moto E14
1272	Motorola Moto E13
1273	Motorola Moto E7
1274	Motorola Moto E7 Plus
1275	Moto E7 Power/E7i Power
1276	Motorola Moto E7 Power
1277	Motorola Moto E7i Power
1278	Motorola Moto E6 Plus
1279	Motorola Moto E6 Play
1280	Motorola Moto E6s (2020)/E6i
1281	Motorola Moto E6s (2020)
1282	Motorola Moto E6i
1283	Motorola Moto E5
1284	Motorola Moto E5 Plus
1285	Motorola Moto E4
1286	Motorola Moto E4 Plus
1287	Motorola Moto Z3 / Z3 Play
1288	Motorola Moto Z3
1289	Motorola Moto Z3 Play
1290	Motorola Moto Z2 Play
1291	Motorola Moto Z
1292	Motorola Moto C
1293	Motorola Moto C Plus
1294	Motorola Moto X4
1295	Motorola One / P30 Play
1296	Motorola One
1297	Motorola P30 Play
1298	Motorola One Vision
1299	Motorola One Zoom
1300	Motorola One Action
1301	Motorola One Macro
1302	Motorola One Hyper
1303	Murena One
1304	Nokia G60 5G
1305	Nokia G50
1306	Nokia G42 5G
1307	Nokia G22
1308	Nokia G10/G20
1309	Nokia G11/G21
1310	Nokia G21
1311	Nokia G20
1312	Nokia G11
1313	Nokia G11 Plus
1314	Nokia G10
1315	Nokia X30 5G
1316	Nokia X10/X20
1317	Nokia X20
1318	Nokia X10
1319	Nokia XR21
1320	Nokia XR20
1321	Nokia C32
1322	Nokia C22
1323	Nokia 9 PureView
1324	Nokia 8.3 5G
1325	Nokia 8.1
1326	Nokia 8
1327	Nokia 8 Sirocco
1328	Nokia 7.2
1329	Nokia 7.1
1330	Nokia 7 Plus
1331	Nokia 6.2 / Nokia 7.2
1332	Nokia 6.2
1333	Nokia 6.1
1334	Nokia 6.1 Plus
1335	Nokia 6
1336	Nokia 5.4
1337	Nokia 5.3
1338	Nokia 5.1
1339	Nokia 5.1 Plus
1340	Nokia 5
1341	Nokia 4.2
1342	Nokia 3.4
1343	Nokia 3.2
1344	Nokia 3.1
1345	Nokia 3.1 Plus
1346	Nokia 3
1347	Nokia 2.2
1348	Nokia 2.1
1349	Nokia 2
1350	Nokia 1.4
1351	Nokia 1
1352	Nokia 1 Plus
1353	Nokia Lumia 630 / 635
1354	Nokia Lumia 635
1355	Nokia Lumia 630
1356	Nokia Lumia 520/525
1357	Nokia Lumia 525
1358	Nokia Lumia 520
1359	Nokia 8210 4G
1360	Nokia 8110 4G
1361	Nokia 6310 (2021)
1362	Nokia 5710 XA
1363	Nokia 5310 (2020)
1364	Nokia 3310 4G
1365	Nokia 3310 (2017)
1366	Nokia 3210 (2024)
1367	Nokia 2660 Flip
1368	Nokia 800 Tough
1369	Nokia 515
1370	Nokia 301
1371	Nokia 235 4G (2024)
1372	Nokia 230
1373	Nokia 225 (2024)
1374	Nokia 225 (2014)
1375	Nokia 216
1376	Nokia 150 (2017)
1377	Nokia 130 (2017)
1378	Nokia 110 (2019)
1379	Nokia 105 (2019)
1380	Nokia Asha 300
1381	Nokia C2-01
1382	Nokia C5-00
1383	Nokia X3-02
1384	Nokia N1
1385	Nokia T21
1386	Nokia T20
1387	Nokia T10
1388	Nothing Phone (4a)
1389	Nothing Phone (4a) Pro
1390	Nothing Phone (4b)
1391	Nothing Phone (3)
1392	Nothing Phone (3a)
1393	Nothing Phone (3a) Pro
1394	Nothing Phone (3a) Lite
1395	Nothing Phone (2)
1396	Nothing Phone (2a)
1397	Nothing Phone (2a) Plus
1398	Nothing Phone (1)
1399	nubia RedMagic 12 Pro/12 Pro+
1400	nubia RedMagic 12 Pro
1401	nubia RedMagic 12 Pro Plus
1402	nubia RedMagic 11 Pro/11 Pro+
1403	nubia RedMagic 11 Pro
1404	nubia RedMagic 11 Pro Plus
1405	nubia RedMagic 11 Air
1406	nubia RedMagic 10 Pro/10 Pro+
1407	nubia RedMagic 10 Pro
1408	nubia RedMagic 10 Pro Plus
1409	nubia RedMagic 10 Air
1410	nubia RedMagic 9 Pro
1411	nubia RedMagic 8 Pro / 8S Pro
1412	nubia RedMagic 8 Pro
1413	nubia RedMagic 8S Pro
1414	nubia Red Magic 5G
1415	nubia Z80 Ultra
1416	nubia Z70 Ultra
1417	nubia Z70S Ultra
1418	nubia Z60 Ultra
1419	nubia Z60S Pro
1420	nubia Z50
1421	nubia Z50 Ultra
1422	nubia Z50S Pro
1423	nubia Air
1424	nubia Air Pro
1425	nubia Focus 2 5G
1426	nubia Focus 2 Ultra 5G
1427	nubia Focus 5G
1428	nubia Focus Pro 5G
1429	nubia Neo 5 GT 5G
1430	nubia Neo 3 GT 5G
1431	nubia Neo 2 5G
1432	nubia Music
1433	nubia Flip 2 5G
1434	nubia Flip 5G
1435	nubia Pad Pro
1436	nubia RedMagic Astra 2
1437	nubia RedMagic Astra
1438	nubia RedMagic Nova
1439	Olympia Neo
1440	Olympia Trek
1441	OnePlus 15
1442	OnePlus 15R
1443	OnePlus 13
1444	OnePlus 13R
1445	OnePlus 12
1446	OnePlus 12R
1447	OnePlus 11
1448	OnePlus 10 Pro
1449	OnePlus 10T
1450	OnePlus 9
1451	OnePlus 9 Pro
1452	OnePlus 8
1453	OnePlus 8 Pro
1454	OnePlus 8T
1455	OnePlus 7
1456	OnePlus 7 Pro
1457	OnePlus 7T
1458	OnePlus 6
1459	OnePlus 6T
1460	OnePlus 5
1461	OnePlus 5T
1462	OnePlus 3
1463	OnePlus 3T
1464	OnePlus 2
1465	OnePlus Nord 6
1466	OnePlus Nord 5
1467	OnePlus Nord 4
1468	OnePlus Nord 3 5G
1469	OnePlus Nord 2 5G
1470	OnePlus Nord 2T
1471	OnePlus Nord
1472	OnePlus Nord CE 6
1473	OnePlus Nord CE 6 Lite
1474	OnePlus Nord CE 5
1475	OnePlus Nord CE 4 Lite 5G
1476	OnePlus Nord CE 2 5G
1477	OnePlus Nord CE 2 Lite 5G
1478	OnePlus Nord CE 5G
1479	OnePlus Nord N100
1480	OnePlus Nord N10 5G
1481	OnePlus Open
1482	OnePlus Pad 3
1483	OnePlus Pad 2
1484	OnePlus Pad 2 Pro
1485	OnePlus Pad
1486	OnePlus Pad Go 2
1487	OnePlus Pad Go
1488	OnePlus Pad Lite
1489	Oppo Find X10
1490	Oppo Find X10 Pro Max
1491	Oppo Find X9
1492	Oppo Find X9 Pro
1493	Oppo Find X9 Ultra
1494	Oppo Find X9s
1495	Oppo Find X8
1496	Oppo Find X8 Pro
1497	Oppo Find X5
1498	Oppo Find X5 Pro
1499	Oppo Find X5 Lite
1500	Oppo Find X3 Pro
1501	Oppo Find X3 Neo
1502	Oppo Find X3 Lite
1503	Oppo Find X2 Pro
1504	Oppo Find X2 Neo
1505	Oppo Find X2 Lite
1506	Oppo Reno16 5G
1507	Oppo Reno16 Pro 5G
1508	Oppo Reno16 F 5G/Reno16 FS 5G
1509	Oppo Reno16 F 5G
1510	Oppo Reno16 FS 5G
1511	Oppo Reno15 5G
1512	Oppo Reno15 Pro 5G
1513	Oppo Reno15 F 5G/Reno15 FS 5G
1514	Oppo Reno15 F 5G
1515	Oppo Reno15 FS 5G
1516	Oppo Reno14 5G
1517	Oppo Reno14 F 5G/Reno14 FS 5G
1518	Oppo Reno14 F 5G
1519	Oppo Reno14 FS 5G
1520	Oppo Reno12 Pro 5G
1521	Oppo Reno10 5G
1522	Oppo Reno10 Pro 5G
1523	Oppo Reno8 Lite 5G
1524	Oppo Reno7 (4G)
1525	Oppo Reno6 5G
1526	Oppo Reno4 5G
1527	Oppo Reno4 Pro 5G
1528	Oppo Reno4 Z 5G
1529	Oppo Reno2
1530	Oppo Reno2 Z
1531	Oppo Reno 5G
1532	Oppo A76 / A96
1533	Oppo A96
1534	Oppo A94 5G
1535	Oppo A91
1536	Oppo A77 5G
1537	Oppo A76
1538	Oppo A54 5G / A74 5G
1539	Oppo A74 5G
1540	Oppo A74 (4G)
1541	Oppo A73 5G
1542	Oppo A52 / A72
1543	Oppo A72
1544	Oppo A54 5G
1545	Oppo A53s
1546	Oppo A52
1547	Oppo A16 / A16s
1548	Oppo A16
1549	Oppo A16s
1550	Oppo A15
1551	Oppo A6 Pro 5G
1552	Oppo A5
1553	Oppo A5 Pro (4G/5G)
1554	Oppo A5 Pro (4G)
1555	Oppo A5 Pro 5G
1556	Oppo Pad 5
1557	Oppo Pad 2
1558	Oppo Pad
1559	Oppo Pad Air 2
1560	Oppo Pad Air
1561	OSCAL C80
1562	OSCAL C70
1563	OSCAL C30 / C30 Pro
1564	OSCAL C30
1565	OSCAL C30 Pro
1566	OSCAL S70 / S70 Pro
1567	OSCAL S70
1568	OSCAL S70 Pro
1569	OSCAL Pilot 8
1570	OSCAL Pilot 6
1571	OSCAL Pilot 5
1572	OSCAL Pilot 3
1573	OSCAL Pilot 2
1574	OSCAL Pilot 1
1575	OSCAL Marine 3
1576	OSCAL Marine 2
1577	OSCAL Marine 1
1578	OSCAL Tank 1
1579	OSCAL Tiger 13
1580	OSCAL Tiger 12
1581	OSCAL Tiger 10
1582	OSCAL Tiger 8
1583	OSCAL Modern 8
1584	OSCAL FLAT 3C
1585	OSCAL FLAT 2
1586	OSCAL FLAT 2C
1587	OSCAL FLAT 1C
1588	OSCAL Flow 2
1589	OSCAL Pad 200
1590	OSCAL Pad 100
1591	OSCAL Pad 90 Pro
1592	OSCAL Pad 90
1593	OSCAL Pad 80 WiFi
1594	OSCAL Pad 70
1595	OSCAL Pad 60
1596	OSCAL Pad 50 WiFi
1597	OSCAL Pad 30 WiFi
1598	OSCAL Pad 18
1599	OSCAL Pad 16
1600	OSCAL Pad 15
1601	OSCAL Pad 13
1602	OSCAL Pad 10
1603	OSCAL Pad 7
1604	OSCAL Pad 5
1605	OSCAL Elite 1
1606	OSCAL Spider 10
1607	OSCAL Spider 8
1608	Oukitel WP500
1609	Oukitel WP500 Ultra
1610	Oukitel WP300
1611	Oukitel WP210
1612	Oukitel WP200 / WP200 Pro
1613	Oukitel WP200
1614	Oukitel WP200 Pro
1615	Oukitel WP100 / WP100 Titan
1616	Oukitel WP100
1617	Oukitel WP100 Titan
1618	Oukitel WP68 Air
1619	Oukitel WP66
1620	Oukitel WP62
1621	Oukitel WP61 5G / Ultra / Ti
1622	Oukitel WP61 5G
1623	Oukitel WP61 Ultra
1624	Oukitel WP61 Ti
1625	Oukitel WP60
1626	Oukitel WP58 / WP58 Pro
1627	Oukitel WP58
1628	Oukitel WP58 Pro
1629	Oukitel WP56
1630	Oukitel WP55 / Pro / Ultra
1631	Oukitel WP55
1632	Oukitel WP55 Pro
1633	Oukitel WP55 Ultra
1634	Oukitel WP53 / Pro / S
1635	Oukitel WP53
1636	Oukitel WP53 Pro
1637	Oukitel WP53 S
1638	Oukitel WP52
1639	Oukitel WP50
1640	Oukitel WP39
1641	Oukitel WP38
1642	Oukitel WP36
1643	Oukitel WP35
1644	Oukitel WP33 Pro
1645	Oukitel WP32
1646	Oukitel WP30 Pro
1647	Oukitel WP28
1648	Oukitel WP27
1649	Oukitel WP26
1650	Oukitel WP23
1651	Oukitel WP20 / WP20 Pro
1652	Oukitel WP20
1653	Oukitel WP20 Pro
1654	Oukitel WP6
1655	Oukitel WP5
1656	Oukitel WP5 Pro
1657	Oukitel C72
1658	Oukitel C69
1659	Oukitel C68
1660	Oukitel C68 Plus
1661	Oukitel C67
1662	Oukitel C66
1663	Oukitel C62/C62 Pro/C62 GT
1664	Oukitel C62
1665	Oukitel C62 Pro
1666	Oukitel C62 GT
1667	Oukitel C61/C61 Pro/C61 GT
1668	Oukitel C61
1669	Oukitel C61 Pro
1670	Oukitel C61 GT
1671	Oukitel C58 / C58 Pro
1672	Oukitel C58
1673	Oukitel C58 Pro
1674	Oukitel C57S / C57 Pro
1675	Oukitel C57S
1676	Oukitel C57 Pro
1677	Oukitel C53
1678	Oukitel C51
1679	Oukitel C50
1680	Oukitel C38
1681	Oukitel C37
1682	Oukitel C35 / C36
1683	Oukitel C36
1684	Oukitel C35
1685	Oukitel C33
1686	Oukitel C32
1687	Oukitel C26
1688	Oukitel C26 Mini
1689	Oukitel C17
1690	Oukitel C17 Plus
1691	Oukitel C7
1692	Oukitel C6
1693	Oukitel C5 (2025)
1694	Oukitel C3 (2025)
1695	Oukitel C2 (2025)
1696	Oukitel C1/C1 Plus/C1 Pro
1697	Oukitel C1
1698	Oukitel C1 Plus
1699	Oukitel C1 Pro
1700	Oukitel G7
1701	Oukitel G6
1702	Oukitel G5
1703	Oukitel G3
1704	Oukitel G2
1705	Oukitel G1
1706	Oukitel K16
1707	Oukitel P2 Plus
1708	Oukitel P1
1709	Oukitel OT12
1710	Oukitel OT11
1711	Oukitel OT8
1712	Oukitel OT5
1713	Oukitel OT5S
1714	Oukitel OKT3
1715	Oukitel RT10
1716	Oukitel RT8
1717	Oukitel RT7
1718	Oukitel RT6
1719	Oukitel RT5
1720	Oukitel RT3
1721	Oukitel RT2
1722	Oukitel RT1
1723	PEAQ PET 101-H232E-13
1724	PEAQ PET 1008-F464E
1725	PEAQ PET 10181-F464E 
1726	PEAQ PET 10980-F628E
1727	PocketBook Verta
1728	PocketBook Verta Color
1729	PocketBook Era
1730	PocketBook Era Lite
1731	PocketBook Era Color
1732	PocketBook InkPad Eo 2
1733	PocketBook InkPad One
1734	PocketBook InkPad 4
1735	PocketBook InkPad Color 3
1736	PocketBook Touch HD 3
1737	PocketBook Touch Lux 5
1738	PocketBook Verse
1739	PocketBook Verse Lite
1740	PocketBook Verse Pro
1741	PocketBook Verse Pro Color
1742	Realme 16 5G
1743	Realme 16 Pro
1744	Realme 16 Pro Plus
1745	Realme 15 5G
1746	Realme 15 Pro 5G
1747	Realme 14 Pro 5G
1748	Realme 14 Pro Plus 5G
1749	Realme 14x 5G
1750	Realme 14T 5G
1751	Realme 13 Pro 5G
1752	Realme 12 (4G)
1753	Realme 12 5G
1754	Realme 12 Plus 5G
1755	Realme 12 Pro/12 Pro Plus 5G
1756	Realme 12 Pro 5G
1757	Realme 12 Pro Plus 5G
1758	Realme 12x 5G
1759	Realme 9 Pro
1760	Realme 9 Pro Plus
1761	Realme 9i
1762	Realme 8 / 8 Pro
1763	Realme 8
1764	Realme 8 Pro
1765	Realme 8 5G
1766	Realme 8i
1767	Realme 7
1768	Realme 7 Pro
1769	Realme 7 5G
1770	Realme 6
1771	Realme 6 Pro
1772	Realme C100
1773	Realme C71
1774	Realme C67 (4G)
1775	Realme C65 (4G)
1776	Realme C51
1777	Realme C35
1778	Realme C25Y
1779	Realme C21
1780	Realme C11 (2021)
1781	Realme GT 8 Pro
1782	Realme GT 7
1783	Realme GT 7T
1784	Realme GT 7 Pro
1785	Realme GT 6
1786	Realme GT 6T
1787	Realme GT2
1788	Realme GT2 Pro
1789	Realme GT 5G
1790	Realme GT Neo 3
1791	Realme GT Neo 3T
1792	Realme GT Neo 2
1793	Realme Narzo 50 (4G)
1794	Realme Narzo 50A Prime / C35
1795	Realme Narzo 50A Prime
1796	Realme P4 5G
1797	Realme P4 Pro 5G
1798	Realme P4 Power 5G
1799	Realme P4 Lite 4G
1800	Realme P4x
1801	Realme P3
1802	Realme P3 Ultra
1803	Realme X50 Pro
1804	Realme Note 60
1805	Realme Note 50
1806	Realme Pad 2
1807	Realme Pad
1808	Realme Pad Mini
1809	Realme Pad X
1810	rephone
1811	RugOne Xsnap 7 Pro
1812	RugOne Xever 8
1813	RugOne Xever 7 / 7 Pro
1814	RugOne Xever 7
1815	RugOne Xever 7 Pro
1816	Samsung Galaxy S26
1817	Samsung Galaxy S26 Plus
1818	Samsung Galaxy S26 Ultra
1819	Samsung Galaxy S26 FE
1820	Samsung Galaxy S25
1821	Samsung Galaxy S25 Plus
1822	Samsung Galaxy S25 Ultra
1823	Samsung Galaxy S25 Edge
1824	Samsung Galaxy S25 FE
1825	Samsung Galaxy S24
1826	Samsung Galaxy S24 Plus
1827	Samsung Galaxy S24 Ultra
1828	Samsung Galaxy S24 FE
1829	Samsung Galaxy S23
1830	Samsung Galaxy S23 Plus
1831	Samsung Galaxy S23 Ultra
1832	Samsung Galaxy S23 FE
1833	Samsung Galaxy S22
1834	Samsung Galaxy S22 Plus
1835	Samsung Galaxy S22 Ultra
1836	Samsung Galaxy S21
1837	Samsung Galaxy S21 Plus
1838	Samsung Galaxy S21 Ultra
1839	Samsung Galaxy S21 FE 5G
1840	Samsung Galaxy S20 / S20 5G
1841	Samsung Galaxy S20
1842	Samsung Galaxy S20 5G
1843	Samsung Galaxy S20 Plus / 5G
1844	Samsung Galaxy S20 Plus
1845	Samsung Galaxy S20 Plus 5G
1846	Samsung Galaxy S20 Ultra / 5G
1847	Samsung Galaxy S20 Ultra
1848	Samsung Galaxy S20 Ultra 5G
1849	Samsung Galaxy S20 FE / FE 5G
1850	Samsung Galaxy S20 FE
1851	Samsung Galaxy S20 FE 5G
1852	Samsung Galaxy S10
1853	Samsung Galaxy S10e
1854	Samsung Galaxy S10 Plus
1855	Samsung Galaxy S10 5G
1856	Samsung Galaxy S10 Lite
1857	Samsung Galaxy S9
1858	Samsung Galaxy S9 Plus
1859	Samsung Galaxy S8
1860	Samsung Galaxy S8 Plus
1861	Samsung Galaxy S7
1862	Samsung Galaxy S7 Edge
1863	Samsung Galaxy S7 active
1864	Samsung Galaxy S6
1865	Samsung Galaxy S6 Edge
1866	Samsung Galaxy S6 Edge Plus
1867	Samsung Galaxy S5 / S5 Neo
1868	Samsung Galaxy S5
1869	Samsung Galaxy S5 Neo
1870	Samsung Galaxy S5 Mini
1871	Samsung Galaxy S4
1872	Samsung Galaxy S4 Mini
1873	Samsung Galaxy S4 active
1874	Samsung Galaxy S3 / S3 Neo
1875	Samsung Galaxy S3
1876	Samsung Galaxy S3 Neo
1877	Samsung Galaxy S3 Mini
1878	Samsung Galaxy S2 / S2 Plus
1879	Samsung Galaxy S2
1880	Samsung Galaxy S2 Plus
1881	Samsung Galaxy S Duos 2
1882	Samsung Galaxy S / S Plus
1883	Samsung Galaxy S
1884	Samsung Galaxy S Plus
1885	Samsung Galaxy A90 5G
1886	Samsung Galaxy A80
1887	Samsung Galaxy A72 / A72 5G
1888	Samsung Galaxy A72
1889	Samsung Galaxy A72 5G
1890	Samsung Galaxy A71
1891	Samsung Galaxy A70
1892	Samsung Galaxy A57 5G
1893	Samsung Galaxy A56 5G
1894	Samsung Galaxy A55 5G
1895	Samsung Galaxy A54 5G
1896	Samsung Galaxy A53 5G
1897	Samsung Galaxy A52 / A52s 5G
1898	Samsung Galaxy A52
1899	Samsung Galaxy A52 5G
1900	Samsung Galaxy A52s 5G
1901	Samsung Galaxy A51
1902	Samsung Galaxy A50 / A30s
1903	Samsung Galaxy A50
1904	Samsung Galaxy A42 5G
1905	Samsung Galaxy A41
1906	Samsung Galaxy A40
1907	Samsung Galaxy A37 5G
1908	Samsung Galaxy A36 5G
1909	Samsung Galaxy A35 5G
1910	Samsung Galaxy A34 5G
1911	Samsung Galaxy A33 5G
1912	Samsung Galaxy A32 5G
1913	Samsung Galaxy A32 (4G)
1914	Samsung Galaxy A31
1915	Samsung Galaxy A30s
1916	Samsung Galaxy A27 5G
1917	Samsung Galaxy A26 5G
1918	Samsung Galaxy A25 5G
1919	Samsung Galaxy A23 5G
1920	Samsung Galaxy A23 (4G)
1921	Samsung Galaxy A22 5G
1922	Samsung Galaxy A22 (4G)
1923	Samsung Galaxy A21s
1924	Samsung Galaxy A20e
1925	Samsung Galaxy A20s
1926	Samsung Galaxy A17/A18(4G/5G)
1927	Samsung Galaxy A17 (4G)
1928	Samsung Galaxy A17 5G
1929	Samsung Galaxy A18 (4G)
1930	Samsung Galaxy A18 5G
1931	Samsung Galaxy A16 (4G/5G)
1932	Samsung Galaxy A16 (4G)
1933	Samsung Galaxy A16 5G
1934	Samsung Galaxy A15 (4G/5G)
1935	Samsung Galaxy A15 (4G)
1936	Samsung Galaxy A15 5G
1937	Samsung Galaxy A14 (4G/5G)
1938	Samsung Galaxy A14 (4G)
1939	Samsung Galaxy A14 5G
1940	Samsung Galaxy A13 5G
1941	Samsung Galaxy A13 (4G)
1942	Samsung Galaxy A12
1943	Samsung Galaxy A10
1944	Samsung Galaxy A10 / M10
1945	Samsung Galaxy A10
1946	Samsung Galaxy A07
1947	Samsung Galaxy A06 (4G/5G)
1948	Samsung Galaxy A06 (4G)
1949	Samsung Galaxy A06 5G
1950	Samsung Galaxy A05s
1951	Samsung Galaxy A04s
1952	Samsung Galaxy A03
1953	Samsung Galaxy A03s
1954	Samsung Galaxy A02s
1955	Samsung Galaxy A9 (2018)
1956	Samsung Galaxy A8 (2018)
1957	Samsung Galaxy A7 (2018)
1958	Samsung Galaxy A7 (2017)
1959	Samsung Galaxy A7 (2016)
1960	Samsung Galaxy A7 (2015)
1961	Samsung Galaxy A6 (2018)
1962	Samsung Galaxy A6 Plus (2018)
1963	Samsung Galaxy A5 (2017)
1964	Samsung Galaxy A5 (2016)
1965	Samsung Galaxy A5 (2015)
1966	Samsung Galaxy A3 (2017)
1967	Samsung Galaxy A3 (2016)
1968	Samsung Galaxy A3 (2015)
1969	Samsung Note 20 / Note20 5G
1970	Samsung Galaxy Note 20
1971	Samsung Galaxy Note 20 5G
1972	Samsung Galaxy Note 20 Ultra 5G
1973	Samsung Galaxy Note 10
1974	Samsung Note 10 Plus (4G/5G)
1975	Samsung Galaxy Note 10 Plus
1976	Samsung Galaxy Note 10 Plus 5G
1977	Samsung Galaxy Note 10 Lite
1978	Samsung Galaxy Note 9
1979	Samsung Galaxy Note 8
1980	Samsung Galaxy Note 5
1981	Samsung Galaxy Note 4
1982	Samsung Galaxy Note 3
1983	Samsung Galaxy Note 3 Neo
1984	Samsung Galaxy Note 2
1985	Samsung Galaxy XCover 7
1986	Samsung Galaxy XCover 7 Pro
1987	Samsung Galaxy Xcover 6 Pro
1988	Samsung Galaxy XCover 5
1989	Samsung Galaxy Xcover Pro
1990	Samsung Galaxy Xcover 4
1991	Samsung Galaxy Xcover 4s
1992	Samsung Galaxy Xcover 3
1993	Samsung Galaxy Z Fold 8 Ultra
1994	Samsung Galaxy Z Fold 8
1995	Samsung Galaxy Z Fold 7
1996	Samsung Galaxy Z Fold 6
1997	Samsung Galaxy Z Fold 5
1998	Samsung Galaxy Z Fold 4
1999	Samsung Galaxy Z Fold 2 5G
2000	Samsung Galaxy Fold
2001	Samsung Galaxy Z Flip 8
2002	Samsung Galaxy Z Flip 7
2003	Samsung Galaxy Z Flip 7 FE
2004	Samsung Galaxy Z Flip 6
2005	Samsung Galaxy Z Flip 5
2006	Samsung Galaxy Z Flip 4
2007	Samsung Galaxy Z Flip
2008	Samsung Galaxy M53 5G
2009	Samsung Galaxy M52 5G
2010	Samsung Galaxy M51
2011	Samsung Galaxy M33 5G
2012	Samsung Galaxy M32
2013	Samsung Galaxy M31
2014	Samsung Galaxy M31s
2015	Samsung Galaxy M30s
2016	Samsung Galaxy M23 5G
2017	Samsung Galaxy M22
2018	Samsung Galaxy M21
2019	Samsung Galaxy M20
2020	Samsung Galaxy M13
2021	Samsung Galaxy M12
2022	Samsung Galaxy M11
2023	Samsung Galaxy M10
2024	Samsung Galaxy J7 (2017)
2025	Samsung Galaxy J7 (2016)
2026	Samsung Galaxy J6 (2018)
2027	Samsung Galaxy J6 Plus
2028	Samsung Galaxy J5 (2017)
2029	Samsung Galaxy J5 (2016)
2030	Samsung Galaxy J5 (2015)
2031	Samsung Galaxy J4 (2018)
2032	Samsung Galaxy J4 Plus
2033	Samsung Galaxy J3 (2018)
2034	Samsung Galaxy J3 (2017)
2035	Samsung Galaxy J3 (2016)
2036	Samsung Galaxy J1 (2016)
2037	Samsung Galaxy J1 (2015)
2038	Samsung Galaxy Ace 2
2039	Samsung Galaxy Ace
2040	Samsung Galaxy Ace Style
2041	Samsung Galaxy Express 2
2042	Samsung Galaxy Grand Prime
2043	Samsung B2710
2044	Samsung Galaxy Tab S12 Ultra
2045	Samsung Galaxy Tab S12 Plus
2046	Samsung Galaxy Tab S11
2047	Samsung Galaxy Tab S11 Ultra
2048	Samsung Galaxy Tab S10 Plus
2049	Samsung Galaxy Tab S10 Ultra
2050	Samsung Galaxy Tab S10 Lite
2051	Samsung Galaxy Tab S10 FE
2052	Samsung Galaxy Tab S10 FE Plus
2053	Samsung Galaxy Tab S9
2054	Samsung Galaxy Tab S9 Plus
2055	Samsung Galaxy Tab S9 Ultra
2056	Samsung Galaxy Tab S9 FE
2057	Samsung Galaxy Tab S9 FE Plus
2058	Samsung Galaxy Tab S8
2059	Samsung Galaxy Tab S8
2060	Samsung Galaxy Tab S8 Plus
2061	Samsung Galaxy Tab S8 Plus
2062	Samsung Galaxy Tab S8 Ultra
2063	Samsung Galaxy Tab S7
2064	Samsung Galaxy Tab S7
2065	Samsung Galaxy Tab S7 Plus
2066	Samsung Galaxy Tab S7 Plus
2067	Samsung Galaxy Tab S7 FE
2068	Samsung Galaxy Tab S7 FE
2069	Galaxy Tab S7 FE / S7+ / S8+
2070	Samsung Galaxy Tab S7 / S8
2071	Samsung Galaxy Tab S5e / S6
2072	Samsung Galaxy Tab S6
2073	Samsung Galaxy Tab S6 Lite
2074	Samsung Galaxy Tab S5e
2075	Samsung Galaxy Tab S4
2076	Samsung Galaxy Tab S3
2077	Samsung Galaxy Tab S2 9.7
2078	Samsung Galaxy Tab S2 8.0
2079	Samsung Galaxy Tab S 10.5
2080	Samsung Galaxy Tab S 8.4
2081	Samsung Galaxy Tab A11
2082	Samsung Galaxy Tab A11 Plus
2083	Samsung Galaxy Tab A9
2084	Samsung Galaxy Tab A9 Plus
2085	Samsung Galaxy Tab A8 (2021)
2086	Samsung Galaxy Tab A7 2020/22
2087	Samsung Galaxy Tab A7 (2022)
2088	Samsung Galaxy Tab A7 (2020)
2089	Samsung Galaxy Tab A7 Lite
2090	Samsung Galaxy Tab A 10.5
2091	Samsung Tab A 10.1 (2019)
2092	Samsung Tab A 10.1 (2016)
2093	Samsung Galaxy Tab A 9.7
2094	Samsung Galaxy Tab A 8.0 2019
2095	Samsung Galaxy Tab A 8.0 2017
2096	Samsung Galaxy Tab A 8 (2015)
2097	Samsung Galaxy Tab A 7.0 2016
2098	Samsung Galaxy Tab Active5
2099	Samsung Galaxy Tab Active5 Pro
2100	Samsung Galaxy Tab Active 4 Pro
2101	Samsung Galaxy Tab Active3
2102	Samsung Galaxy Tab Active Pro
2103	Samsung Galaxy Tab Active 2
2104	Samsung Galaxy Tab 4 10.1
2105	Samsung Galaxy Tab 4 7.0
2106	Samsung Galaxy Tab 4 8.0
2107	Samsung Galaxy Tab 3 10.1
2108	Samsung Galaxy Tab 3 7.0
2109	Samsung Galaxy Tab 3 7.0 Lite
2110	Samsung Galaxy Tab 3 8.0
2111	Samsung Galaxy Tab 2 10.1
2112	Samsung Galaxy Tab 2 7.0
2113	Samsung Galaxy Tab E 9.6
2114	Samsung Galaxy Tab J
2115	Samsung Galaxy Tab Pro 10.1
2116	Samsung Galaxy Tab Pro 12.2
2117	Samsung Galaxy Tab Pro 8.4
2118	Samsung Galaxy Note 10.1
2119	Samsung Galaxy Watch Ultra 2
2120	Samsung Galaxy Watch Ultra
2121	Samsung Galaxy Watch9 (40mm)
2122	Samsung Galaxy Watch9 (44mm)
2123	Samsung Galaxy Watch8 (40mm)
2124	Samsung Galaxy Watch8 (44mm)
2125	Samsung Galaxy Watch8 Classic 46mm
2126	Samsung Galaxy Watch7 (40mm)
2127	Samsung Galaxy Watch7 (44mm)
2128	Samsung Galaxy Watch6 (40mm)
2129	Samsung Galaxy Watch6 (44mm)
2130	Samsung Galaxy Watch6 Classic 43mm
2131	Samsung Galaxy Watch6 Classic 47mm
2132	Samsung Galaxy Watch5 (40mm)
2133	Samsung Galaxy Watch5 (44mm)
2134	Samsung Galaxy Watch5 Pro
2135	Samsung Galaxy Watch4 (40mm)
2136	Samsung Galaxy Watch4 (44mm)
2137	Samsung Galaxy Watch4 Classic 42mm
2138	Samsung Galaxy Watch4 Classic 46mm
2139	Samsung Galaxy Watch3 (41mm)
2140	Samsung Galaxy Watch3 (45mm)
2141	Samsung Galaxy Watch 1 (42mm)
2142	Samsung Galaxy Watch 1 (46mm)
2143	Samsung Galaxy Watch Active2 40mm
2144	Samsung Galaxy Watch Active2 44mm
2145	Samsung Galaxy Watch Active
2146	Samsung Galaxy Buds 2 Pro/2/Live/Pro
2147	Samsung Galaxy Buds 2 Pro
2148	Samsung Galaxy Buds 2
2149	Samsung Galaxy Buds Live
2150	Samsung Galaxy Buds Pro
2151	SHIFTphone 8
2152	Shift 6mq
2153	Sonim XP Pro Thermal
2154	Sony Xperia 10 VIII
2155	Sony Xperia 10 VII
2156	Sony Xperia 10 VI
2157	Sony Xperia 10 V
2158	Sony Xperia 10 IV
2159	Sony Xperia 10 III
2160	Sony Xperia 10 II
2161	Sony Xperia 10 Plus
2162	Sony Xperia 10
2163	Sony Xperia 5 V
2164	Sony Xperia 5 IV
2165	Sony Xperia 5 III
2166	Sony Xperia 5 II
2167	Sony Xperia 5
2168	Sony Xperia 1 VIII
2169	Sony Xperia 1 VII
2170	Sony Xperia 1 VI
2171	Sony Xperia 1 V
2172	Sony Xperia 1 IV
2173	Sony Xperia 1 III
2174	Sony Xperia 1 II
2175	Sony Xperia 1
2176	Sony Xperia Pro-I
2177	Sony Xperia L4
2178	Sony Xperia L3
2179	Sony Xperia L2
2180	Sony Xperia XZ3
2181	Sony Xperia XZ2
2182	Sony Xperia XZ2 Compact
2183	Sony Xperia XZ1
2184	Sony Xperia XZ1 Compact
2185	Sony Xperia XZ
2186	Sony Xperia XZs
2187	Sony Xperia XZ Premium
2188	Sony Xperia X
2189	Sony Xperia X Compact
2190	Sony Xperia XA2
2191	Sony Xperia XA2 Plus
2192	Sony Xperia XA2 Ultra
2193	Sony Xperia XA1
2194	Sony Xperia XA1 Plus
2195	Sony Xperia XA1 Ultra
2196	Sony Xperia XA
2197	Sony Xperia Z5
2198	Sony Xperia Z5 Compact
2199	Sony Xperia Z5 Premium
2200	Sony Xperia Z3
2201	Sony Xperia Z3 Compact
2202	Sony Xperia Z3 Plus
2203	Sony Xperia Z2
2204	Sony Xperia Z1
2205	Sony Xperia Z1 Compact
2206	Sony Xperia Z
2207	Sony Xperia E5
2208	Sony Xperia E3
2209	Sony Xperia M5
2210	Sony Xperia M4 Aqua
2211	Sony Xperia Z4 Tablet
2212	Sony Xperia Z3 Tablet Compact
2213	Sony Xperia Z2 Tablet
2214	Swisstone BBM 320C
2215	TABWEE K10
2216	TABWEE T90
2217	TABWEE T80
2218	TABWEE T60
2219	TABWEE T60 Pro
2220	TABWEE T50
2221	TABWEE T20
2222	TABWEE W90
2223	TCL P80 / P80 Pro
2224	TCL P80
2225	TCL P80 Pro
2226	TCL P80 Ultra
2227	TCL K70 5G
2228	TCL TAB 11
2229	TCL TAB 10 Gen 2
2230	TCL TAB 10 FHD 4G (Gen 1)
2231	TCL TAB 10L (Gen 2)
2232	TCL TAB 10L (Gen 1)
2233	TCL TAB 10s 5G
2234	TCL TAB 8
2235	TCL NXTPAPER 14
2236	TCL NXTPAPER 12 Pro
2237	TCL NXTPAPER 11
2238	TCL NXTPAPER 11 Plus
2239	TCL NXTPAPER 10s
2240	TECLAST M50
2241	TECLAST M50HD
2242	TECLAST M50 Pro
2243	TECLAST M50T
2244	TECLAST M40 Air
2245	TECLAST M40 Plus
2246	TECLAST M40 Pro
2247	TECLAST P85T
2248	TECLAST P80T
2249	TECLAST P50
2250	TECLAST P40HD
2251	TECLAST P40S
2252	TECLAST P30S
2253	TECLAST P30T
2254	TECLAST P26T
2255	TECLAST P25T
2256	TECLAST P20S
2257	TECLAST T70
2258	TECLAST T70 Pro
2259	TECLAST T60
2260	TECLAST T60 Pro
2261	TECLAST T50
2262	TECLAST T50 Pro
2263	TECLAST T45HD
2264	TECLAST T40HD
2265	TECLAST T40S
2266	TECLAST T40 Air
2267	TECLAST T40 Pro
2268	Telekom T Phone 3
2269	Telekom T Phone 3 Pro
2270	Telekom T Phone 2
2271	Telekom T Phone 2 Pro
2272	Telekom T Phone
2273	Telekom T Phone Pro
2274	Telekom T Tablet 2
2275	Telekom T Tablet
2276	Tolino Shine Color
2277	Tolino Shine 5
2278	Tolino Shine 4
2279	Tolino Epos 3
2280	Tolino Vision Color
2281	Tolino Vision 6
2282	Tolino Page 2
2283	Ulefone Armor 34 / 34 Pro
2284	Ulefone Armor 34
2285	Ulefone Armor 34 Pro
2286	Ulefone Armor 33 / 33 Pro
2287	Ulefone Armor 33
2288	Ulefone Armor 33 Pro
2289	Ulefone Armor 30 / 30 Pro
2290	Ulefone Armor 30
2291	Ulefone Armor 30 Pro
2292	Ulefone Armor 29 Ultra
2293	Ulefone Armor 28 Pro/28 Ultra
2294	Ulefone Armor 28 Pro
2295	Ulefone Armor 28 Ultra
2296	Ulefone Armor 27 Pro/27T Pro
2297	Ulefone Armor 27 Pro
2298	Ulefone Armor 27T Pro
2299	Ulefone Armor 26 Ultra
2300	Ulefone Armor 25T / 25T Pro
2301	Ulefone Armor 25T
2302	Ulefone Armor 25T Pro
2303	Ulefone Armor 24
2304	Ulefone Armor 23 Ultra
2305	Ulefone Armor X32 / X32 Pro
2306	Ulefone Armor X32
2307	Ulefone Armor X32 Pro
2308	Ulefone Armor X31 / X31 Pro
2309	Ulefone Armor X31
2310	Ulefone Armor X31 Pro
2311	Ulefone Armor X16 / X16 Pro
2312	Ulefone Armor X16
2313	Ulefone Armor X16 Pro
2314	Ulefone Armor X13
2315	Ulefone Armor X12 Pro
2316	Ulefone Armor X10 / X10 Pro
2317	Ulefone Armor X10
2318	Ulefone Armor X10 Pro
2319	Ulefone Armor X8 / X8i
2320	Ulefone Armor X8
2321	Ulefone Armor X8i
2322	Ulefone Armor X6
2323	Ulefone Armor X5
2324	Ulefone Armor Mini 20/20T Pro
2325	Ulefone Armor Mini 20 Pro
2326	Ulefone Armor Mini 20T Pro
2327	Ulefone Armor Mini 5
2328	Ulefone Armor Mini 4
2329	Ulefone Power Armor 16S
2330	Ulefone Note 23
2331	Ulefone Note 22
2332	Ulefone Note 21
2333	Ulefone Note 20 Pro
2334	Ulefone Note 19
2335	Ulefone Note 18 Ultra
2336	Ulefone Note 17 Pro
2337	Ulefone Note 16 Pro
2338	Ulefone Note 15
2339	Ulefone Note 14 / Note 14 Pro
2340	Ulefone Note 14
2341	Ulefone Note 14 Pro
2342	Ulefone RugKing 5 Pro
2343	Ulefone RugKing 4 Pro
2344	Ulefone RugKing 3 Pro
2345	Ulefone RugKing 2 Pro
2346	Ulefone RugKing
2347	Ulefone RugKing Pad Pro
2348	Ulefone RugKing Pad 2 Pro
2349	Ulefone Armor Pad 5 Ultra
2350	Ulefone Armor Pad 5 Pro
2351	Ulefone Armor Pad 4 Ultra
2352	Ulefone Armor Pad 3 Pro
2353	Ulefone Armor Pad 2
2354	Ulefone Armor Pad
2355	Ulefone Armor Pad Pro
2356	Ulefone Armor Pad Lite
2357	Ulefone Tab A11 / Tab A11 Pro
2358	Ulefone Tab A11
2359	Ulefone Tab A11 Pro
2360	Ulefone Tab A10 / Tab A10 Pro
2361	Ulefone Tab A10
2362	Ulefone Tab A10 Pro
2363	Ulefone Tab A9 Pro
2364	Ulefone Tab A8
2365	Ulefone Tab A7
2366	Ulefone Tab W10
2367	Umidigi A75x
2368	Umidigi A15 Pro 5G
2369	Umidigi A15 / A15C
2370	Umidigi A15
2371	Umidigi A15C
2372	Umidigi C1
2373	Umidigi G100 / G100A
2374	Umidigi G100
2375	Umidigi G100A
2376	Umidigi G100 5G / G100 Pro
2377	Umidigi G100 5G
2378	Umidigi G100 Pro
2379	Umidigi G100x / G100x 5G
2380	Umidigi G100x
2381	Umidigi G100x 5G
2382	Umidigi G9 5G
2383	Umidigi G9A
2384	Umidigi G9C / G9T
2385	Umidigi G9C
2386	Umidigi G9T
2387	Umidigi G9x
2388	Umidigi G6 5G
2389	Umidigi X
2390	Umidigi Bison X20
2391	Umidigi Bison X10 / X10 Pro
2392	Umidigi Bison X10
2393	Umidigi Bison X10 Pro
2394	Umidigi Note 100/100 5G/100A
2395	Umidigi Note 100
2396	Umidigi Note 100 5G
2397	Umidigi Note 100A
2398	Umidigi Note 100x / 100x 5G
2399	Umidigi Note 100x
2400	Umidigi Note 100x 5G
2401	Umidigi Note 90
2402	Umidigi A15 Tab
2403	Umidigi A13 Tab
2404	Umidigi A11 Tab
2405	Umidigi G9 Tab
2406	Umidigi G7 Tab Pro
2407	Umidigi G5 Tab
2408	Umidigi G3 Tab
2409	Umidigi G3 Tab Ultra
2410	Umidigi G2 Tab
2411	Umidigi G1 Tab
2412	Umidigi G1 Tab Mini
2413	Umidigi Active T1
2414	vivo X Fold 6
2415	vivo X500 Pro
2416	vivo X500 Pro Max
2417	vivo X300
2418	vivo X300 Pro
2419	vivo X300 Ultra
2420	vivo X300 FE
2421	vivo X200
2422	vivo X200 Pro
2423	vivo X200 FE
2424	vivo X100 Pro
2425	vivo X90 Pro
2426	vivo X80 Pro
2427	vivo X60 Pro
2428	vivo X51 5G
2429	vivo V70 5G
2430	vivo V70 FE
2431	vivo V50 5G
2432	vivo V50 Lite (4G/5G)
2433	vivo V50 Lite (4G)
2434	vivo V50 Lite 5G
2435	vivo V40 5G
2436	vivo V40 Lite 5G
2437	vivo V40 SE (4G/5G)
2438	vivo V40 SE (4G)
2439	vivo V40 SE 5G
2440	vivo V29 Lite
2441	vivo V23 5G
2442	vivo V21 5G
2443	vivo Y76 5G
2444	vivo Y72 5G
2445	vivo Y70
2446	vivo Y36
2447	vivo Y33s
2448	vivo Y29s
2449	vivo Y21 / Y21s / Y33s
2450	vivo Y21
2451	vivo Y21s
2452	vivo Y20s
2453	Vodafone Tab Prime 7
2454	Volla Phone Plinius
2455	Volla Phone Quintus
2456	Volla Phone X23
2457	Volla Phone 22
2458	Volla Phone
2459	Volla Tablet
2460	Whitedeer G13
2461	Whitedeer A10 Pro
2462	Wiko Lenny
2463	Wiko Power U30
2464	Wiko Power U10 / U20
2465	Wiko Power U20
2466	Wiko Power U10
2467	Wiko View4
2468	Wiko View3 Lite
2469	Wiko View
2470	Wiko Y82
2471	Wiko Y61
2472	Xiaomi 18 Pro
2473	Xiaomi 18 Pro Max
2474	Xiaomi 17
2475	Xiaomi 17 Ultra
2476	Xiaomi 17T
2477	Xiaomi 17T Pro
2478	Xiaomi 15
2479	Xiaomi 15 Ultra
2480	Xiaomi 15T
2481	Xiaomi 15T Pro
2482	Xiaomi 14
2483	Xiaomi 14 Ultra
2484	Xiaomi 14T
2485	Xiaomi 14T Pro
2486	Xiaomi 13
2487	Xiaomi 13 Pro
2488	Xiaomi 13 Lite
2489	Xiaomi 13 Ultra
2490	Xiaomi 13T / 13T Pro
2491	Xiaomi 13T
2492	Xiaomi 13T Pro
2493	Xiaomi 12 / Xiaomi 12X
2494	Xiaomi 12
2495	Xiaomi 12X
2496	Xiaomi 12 Pro
2497	Xiaomi 12 Lite
2498	Xiaomi 12T / 12T Pro
2499	Xiaomi 12T
2500	Xiaomi 12T Pro
2501	Xiaomi Mi 11
2502	Xiaomi Mi 11i / Poco F3
2503	Xiaomi Mi 11i
2504	Xiaomi Mi 11 Lite/11 Lite 5G
2505	Xiaomi Mi 11 Lite
2506	Xiaomi Mi 11 Lite 5G
2507	Xiaomi Mi 11 Ultra
2508	Xiaomi 11T / 11T Pro
2509	Xiaomi 11T
2510	Xiaomi 11T Pro
2511	Xiaomi Mi 10
2512	Xiaomi Mi 10 Pro
2513	Xiaomi Mi 10 Lite 5G
2514	Xiaomi Mi 10T / Mi 10T Pro
2515	Xiaomi Mi 10T
2516	Xiaomi Mi 10T Pro
2517	Xiaomi Mi 10T Lite
2518	Xiaomi Mi 9 / Mi 9 Explorer
2519	Xiaomi Mi 9
2520	Xiaomi Mi 9 Explorer
2521	Xiaomi Mi 9 Pro
2522	Xiaomi Mi 9 SE
2523	Xiaomi Mi 9 Lite
2524	Xiaomi Mi 9T / Mi 9T Pro
2525	Xiaomi Mi 9T
2526	Xiaomi Mi 9T Pro
2527	Xiaomi Mi 8
2528	Redmi Note 17 (4G/5G)
2529	Redmi Note 17 (4G)
2530	Redmi Note 17 5G
2531	Redmi Note 17 Pro 5G
2532	Redmi Note 17 Pro Max 5G
2533	Redmi Note 15 (4G)
2534	Redmi Note 15 5G
2535	Redmi Note 15 Pro (4G)
2536	Redmi Note 15 Pro 5G
2537	Redmi Note 15 Pro+ 5G
2538	Redmi Note 14 (4G)
2539	Redmi Note 14 5G
2540	Redmi Note 14 Pro (4G)
2541	Redmi Note 14 Pro 5G
2542	Redmi Note 14 Pro+ 5G
2543	Redmi Note 13 (4G)
2544	Redmi Note 13 5G
2545	Redmi Note 13 Pro (4G)
2546	Redmi Note 13 Pro 5G
2547	Redmi Note 13 Pro+ 5G
2548	Redmi Note 12 (4G)
2549	Redmi Note 12 5G
2550	Redmi Note 12S
2551	Redmi Note 12 Pro (4G)
2552	Redmi Note 12 Pro 5G
2553	Redmi Note 12 Pro+ 5G
2554	Redmi Note 11/Note 11S
2555	Redmi Note 11
2556	Redmi Note 11S
2557	Redmi Note 11 Pro/11 Pro 5G
2558	Redmi Note 11 Pro
2559	Redmi Note 11 Pro 5G
2560	Redmi Note 11 Pro+ 5G
2561	Redmi Note 10/Note 10S
2562	Redmi Note 10
2563	Redmi Note 10S
2564	Redmi Note 10 Pro
2565	Redmi Note 10 5G/Poco M3 Pro
2566	Redmi Note 10 5G
2567	Redmi Note 9
2568	Redmi Note 9 Pro
2569	Redmi Note 9S
2570	Redmi Note 9T
2571	Redmi Note 8
2572	Redmi Note 8 Pro
2573	Redmi Note 8T
2574	Redmi Note 7/ Note 7 Pro / 7S
2575	Redmi Note 7
2576	Redmi Note 7 Pro
2577	Redmi Note 7S
2578	Redmi Note 5
2579	Redmi 17 (4G/5G)
2580	Redmi 17 (4G)
2581	Redmi 17 5G
2582	Redmi 17C 5G
2583	Redmi 15 (4G)
2584	Redmi 15 5G
2585	Redmi 15C (4G/5G)
2586	Redmi 15C (4G)
2587	Redmi 15C 5G
2588	Redmi 14C / Poco C75
2589	Redmi 14C
2590	Redmi 13
2591	Redmi 13C / Poco C65
2592	Redmi 13C
2593	Redmi 12
2594	Redmi 12C
2595	Redmi 10
2596	Redmi 10C
2597	Redmi 9
2598	Redmi 9A
2599	Redmi 9AT
2600	Redmi 9C
2601	Redmi 9T
2602	Redmi 8
2603	Redmi 8A
2604	Redmi 7
2605	Redmi 7A
2606	Redmi A7 Pro
2607	Redmi A5
2608	Redmi A3
2609	Redmi A2
2610	Redmi A1
2611	Xiaomi Mi A3
2612	Xiaomi Mi A2
2613	Xiaomi Mi A2 Lite
2614	Xiaomi Mi A1
2615	Xiaomi MIX Flip
2616	Xiaomi Mi Mix 2S
2617	Xiaomi Mi Mix 3
2618	Xiaomi Mi Note 10/Note 10 Pro
2619	Xiaomi Mi Note 10
2620	Xiaomi Mi Note 10 Pro
2621	Xiaomi Mi Note 10 Lite
2622	Poco F9 Pro
2623	Poco F9 Ultra
2624	Poco F8 Pro
2625	Poco F8 Ultra
2626	Poco F7
2627	Poco F7 Pro
2628	Poco F7 Ultra
2629	Poco F6
2630	Poco F6 Pro
2631	Poco F5
2632	Poco F5 Pro
2633	Poco F4
2634	Poco F4 GT
2635	Poco F3
2636	Poco F2 Pro
2637	Pocophone F1
2638	Poco X8 Pro
2639	Poco X8 Pro Max
2640	Poco X7
2641	Poco X7 Pro
2642	Poco X6
2643	Poco X6 Pro
2644	Poco X5 5G
2645	Poco X5 Pro 5G
2646	Poco X4 Pro 5G
2647	Poco X4 GT
2648	Poco X3 NFC / X3 Pro
2649	Poco X3 NFC
2650	Poco X3 Pro
2651	Poco M8 5G
2652	Poco M8 Pro 5G
2653	Poco M7 (4G)
2654	Poco M7 Pro 5G
2655	Poco M6 (4G)
2656	Poco M6 Pro (4G)
2657	Poco M5
2658	Poco M5s
2659	Poco M4 5G
2660	Poco M4 Pro 5G
2661	Poco M4 Pro
2662	Poco M3
2663	Poco M3 Pro 5G
2664	Poco C85
2665	Poco C81 / C81 Pro
2666	Poco C81
2667	Poco C81 Pro
2668	Poco C75
2669	Poco C65
2670	Poco C40
2671	Xiaomi Pad Mini
2672	Xiaomi Pad 8
2673	Xiaomi Pad 8 Pro
2674	Xiaomi Pad 7
2675	Xiaomi Pad 7 Pro
2676	Xiaomi Pad 6
2677	Xiaomi Pad 6S Pro 12.4
2678	Xiaomi Pad 5
2679	Xiaomi Mi Pad 3
2680	Xiaomi Mi Pad 2
2681	Redmi Pad 2
2682	Redmi Pad 2 9.7
2683	Redmi Pad 2 Pro
2684	Redmi Pad
2685	Redmi Pad Pro
2686	Redmi Pad SE
2687	Redmi Pad SE 8.7
2688	Poco Pad C1
2689	Poco Pad M1
2690	Poco Pad X1
2691	Poco Pad
2692	Poco Watch
2693	Xiaomi Smart Band 8
2694	Redmi Watch 5 Active
2695	ZTE Blade A75
2696	ZTE Blade A73 (4G)
2697	ZTE Blade A73 5G
2698	ZTE Blade A72 5G
2699	ZTE Blade A71
2700	ZTE Blade A55
2701	ZTE Blade A54
2702	ZTE Blade A52
2703	ZTE Blade A51
2704	ZTE Blade A35e
2705	ZTE Blade A34
2706	ZTE Blade A32
2707	ZTE Blade A31
2708	ZTE Blade A31 Lite
2709	ZTE Blade A7 2020
2710	ZTE Blade A7 2019
2711	ZTE Blade A5 2020
2712	ZTE Blade A3 2020
2713	ZTE Blade V70
2714	ZTE Blade V70 Max
2715	ZTE Blade V70 Vita
2716	ZTE Blade V60 Vita
2717	ZTE Blade V50
2718	ZTE Blade V50 Vita
2719	ZTE Blade V50s
2720	ZTE Blade V40s
2721	ZTE Blade V30
2722	ZTE Blade V30 Vita
2723	ZTE Blade V2020
2724	ZTE Blade 10
2725	ZTE Blade 10 Vita
2726	ZTE Axon 40 Ultra
2727	ZTE Axon 11 / Axon 11 5G
2728	ZTE Axon 11
2729	ZTE Axon 11 5G
2730	ZTE Axon 10 Pro
2731	ZTE M9
2732	ZTE nubia Pad 3D
`;

let isEnabled = true;

// SETTINGS END, DO NOT EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        if (!isEnabled || isEnabled === 'false') { return }

        let filterAttr = 'filter_metafield_3f0b03c8f85314eb30d1544ffab0be93';

        function parseImportIntoObject() {
            // trim any extra new line characters in the beginning and end of the user input
            filterImport = filterImport.replaceAll(/^\D+\n/g, '');
            filterImport = filterImport.replaceAll(/\D+\n$/g, '');
            
            let positionsArray = filterImport.replaceAll(/\t.+\n/g, ' ').trim().replaceAll('\\n', '').replaceAll('\\t', '').split(' ');
            
            let valuesArray = filterImport.split(/\n.+\t/);
            if (valuesArray[0] === '') {
                valuesArray.shift();
            }
            if (valuesArray[valuesArray.length - 1].includes('\n')) {
                valuesArray[valuesArray.length - 1] = valuesArray[valuesArray.length - 1].replace('\n', '');
            }

            let valuesPositionsObject = {};

            for (let i = 0; i < positionsArray.length; i++) {
                valuesPositionsObject[valuesArray[i]] = positionsArray[i];
            }
            
            return valuesPositionsObject;
        }

        function findAllOptionsInOrder(filterData, valuesPositionsObject) {
            console.log('findAllOptionsInOrder');
            console.log(filterData);
            let filterDataOptionsObject = {};
            for (let bucket of filterData.buckets) {
                filterDataOptionsObject[bucket.value] = bucket.count;
            }

            let availableImportValuesArray = [];
            let valuesNotFoundInImportArray = [];
            Object.keys(filterDataOptionsObject).forEach(function(item) {
                if (valuesPositionsObject[item]) {
                    availableImportValuesArray.push({'value': item, 'count': filterDataOptionsObject[item]})
                } else {
                    valuesNotFoundInImportArray.push({'value': item, 'count': filterDataOptionsObject[item]})
                }
            });
            
            let availableImportValuesArrayInOrder = [];
            
            for (let entry of Object.entries(valuesPositionsObject)) {
                for (let item of availableImportValuesArray) {
                    if (item.value == entry[0]) {
                        availableImportValuesArrayInOrder[entry[1]] = item;
                    }
                }
            }
            
            availableImportValuesArrayInOrder = availableImportValuesArrayInOrder.filter(function(item) {
                return item ? true : false; 
            })

            let allOptionsArray = [...availableImportValuesArrayInOrder, ...valuesNotFoundInImportArray];

            return allOptionsArray;
        }

        function findAppliedFilterOptions(params, valuesInOrder) {
            if (params && params.restrictBy && params.restrictBy[filterAttr]) {
                let appliedValuesList;
                if (params.restrictBy[filterAttr].includes('|')) {
                    appliedValuesList = params.restrictBy[filterAttr].split('|');
                } else if (params.restrictBy[filterAttr].includes(',')) {
                    appliedValuesList = params.restrictBy[filterAttr].split(',');
                } else {
                    appliedValuesList = params.restrictBy[filterAttr].split();
                }

                for (let option of valuesInOrder) {
                    if (appliedValuesList.includes(option.value)) {
                        option.selected = 'true';
                    }
                }
            }

            return valuesInOrder;
        }

        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (type == 'results' && data && data.facets) {
                let filterData;
                let filterIndex;

                data.facets.forEach(function(item, index) {
                    if (item.attribute == filterAttr) {
                        filterData = { ...item };
                        filterIndex = index;
                    }
                })

                if (!filterData) { return }

                let valuesPositionsObject = parseImportIntoObject();
                let valuesInOrder = findAllOptionsInOrder(filterData, valuesPositionsObject);
                let valuesWithSelected = findAppliedFilterOptions(params, valuesInOrder);

                data.facets[filterIndex].buckets = valuesWithSelected;
            }   
        });
    })(window.Searchanise.$);
});
}
snizeCustomFilterOptionsOrder();